import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import ModalConfirmar from '../components/ModalConfirmar';
import { PainelEficiencia } from './Sdr';

function ehVagner() {
  try {
    const t = localStorage.getItem('token');
    if (!t) return false;
    // JWT usa base64url: normaliza antes do atob (senão '-'/'_' quebram a decodificação)
    return JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).email === 'vagnerfreittas@gmail.com';
  } catch { return false; }
}

// 👁️ Modo privacidade (olhinho): esconde os NÚMEROS das abas Mercado, Vendas
// e Serviços pra dar pra mostrar a tela sem expor valores. Chave de módulo,
// definida a cada render do Relatorios() ANTES dos filhos renderizarem —
// nas demais abas ela é sempre false, então nada muda lá.
let PRIVADO = false;
const nPriv = (v) => (PRIVADO ? '•••' : v);

const ETAPAS = [
  { key: 'lead',        label: 'Lead',        cor: '#6b7280' },
  { key: '1contato',    label: '1º Contato',  cor: '#3b82f6' },
  { key: 'viabilidade', label: 'Viabilidade', cor: '#f59e0b' },
  { key: 'negociacao',  label: 'Negociação',  cor: '#8b5cf6' },
  { key: 'ganho',       label: 'Ganho',       cor: '#16a34a' },
  { key: 'perdido',     label: 'Perdido',     cor: '#dc2626' },
];

const inp = { padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', background: '#fff', height: 26 };
const th = { padding: '5px 10px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em', background: '#0a1628', whiteSpace: 'nowrap' };
const td = { padding: '4px 10px', fontSize: 13, color: '#374151', borderBottom: '1px solid #e8eaed' };

function token() { return localStorage.getItem('token'); }

async function apiFetch(url, opts = {}) {
  const res = await fetch(url, {
    ...opts,
    headers: { Authorization: `Bearer ${token()}`, ...(opts.body ? { 'Content-Type': 'application/json' } : {}), ...(opts.headers || {}) },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.erro || 'Erro');
  return data;
}

function brt(d = new Date()) {
  return new Date(new Date(d).getTime() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

/* ── Aba: Comercial (Oportunidades por SDR) ── */
function RelatorioComercial() {
  const hojeStr = brt();
  const [oportunidades, setOportunidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroDe, setFiltroDe] = useState(hojeStr);
  const [filtroAte, setFiltroAte] = useState(hojeStr);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiFetch('/oportunidades');
      setOportunidades(data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const filtradas = oportunidades.filter(op => {
    if (filtroDe && new Date(op.criado_em) < new Date(filtroDe)) return false;
    if (filtroAte && new Date(op.criado_em) > new Date(filtroAte + 'T23:59:59')) return false;
    return true;
  });

  const porSdr = {};
  for (const op of filtradas) {
    const sdr = op.sdr || '(sem SDR)';
    if (!porSdr[sdr]) porSdr[sdr] = { total: 0, etapas: {} };
    porSdr[sdr].total++;
    porSdr[sdr].etapas[op.etapa] = (porSdr[sdr].etapas[op.etapa] || 0) + 1;
  }

  const sdrs = Object.entries(porSdr).sort((a, b) => b[1].total - a[1].total);
  const totalGeral = filtradas.length;
  const totalGanho = filtradas.filter(op => op.etapa === 'ganho').length;
  const totalPerdido = filtradas.filter(op => op.etapa === 'perdido').length;
  const taxaConversao = totalGeral > 0 ? ((totalGanho / totalGeral) * 100).toFixed(1) : '0.0';

  return (
    <div>
      {/* Cards resumo */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 8, marginBottom: 14 }}>
        {[
          { label: 'Total', valor: totalGeral, cor: '#0a1628' },
          { label: 'Ganhos', valor: totalGanho, cor: '#16a34a' },
          { label: 'Perdidos', valor: totalPerdido, cor: '#dc2626' },
          { label: 'Conversão', valor: taxaConversao + '%', cor: '#8b5cf6' },
          { label: 'SDRs Ativos', valor: sdrs.filter(([s]) => s !== '(sem SDR)').length, cor: '#3b82f6' },
        ].map(({ label, valor, cor }) => (
          <div key={label} style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: '10px 14px' }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: cor }}>{valor}</div>
            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Filtro de período */}
      <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', marginBottom: 12 }}>
        <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Filtrar por período
        </div>
        <div style={{ padding: '8px 12px' }}>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
            {[
              { label: 'Hoje',          fn: () => { const h = brt(); setFiltroDe(h); setFiltroAte(h); } },
              { label: 'Ontem',         fn: () => { const s = brt(Date.now() - 86400000); setFiltroDe(s); setFiltroAte(s); } },
              { label: 'Últimos 7 dias',fn: () => { setFiltroDe(brt(Date.now() - 6 * 86400000)); setFiltroAte(brt()); } },
              { label: 'Mês atual',     fn: () => { const h = new Date(Date.now() - 3*3600000); const i = new Date(h.getFullYear(), h.getMonth(), 1); setFiltroDe(brt(i)); setFiltroAte(brt()); } },
              { label: 'Todos',         fn: () => { setFiltroDe(''); setFiltroAte(''); } },
            ].map(({ label, fn }) => (
              <button key={label} onClick={fn}
                style={{ background: '#f0f4ff', color: '#0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: '1px solid #0a162822', cursor: 'pointer' }}>
                {label}
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <label style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'nowrap' }}>De</label>
              <input type="date" value={filtroDe} onChange={e => setFiltroDe(e.target.value)} style={inp} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <label style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'nowrap' }}>Até</label>
              <input type="date" value={filtroAte} onChange={e => setFiltroAte(e.target.value)} style={inp} />
            </div>
            {(filtroDe || filtroAte) && (
              <button onClick={() => { setFiltroDe(''); setFiltroAte(''); }}
                style={{ background: '#f3f4f6', color: '#374151', padding: '3px 10px', fontSize: 12, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>
                Limpar
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Tabela por SDR */}
      <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden' }}>
        <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Oportunidades por SDR</span>
          <span style={{ fontSize: 11, color: '#6b7280' }}>{filtradas.length} oportunidade(s) no período</span>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
        ) : sdrs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Nenhuma oportunidade encontrada</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={th}>SDR</th>
                  <th style={{ ...th, textAlign: 'center' }}>Total</th>
                  {ETAPAS.map(e => (
                    <th key={e.key} style={{ ...th, textAlign: 'center' }}>{e.label}</th>
                  ))}
                  <th style={{ ...th, textAlign: 'center' }}>Conversão</th>
                </tr>
              </thead>
              <tbody>
                {sdrs.map(([sdr, dados], i) => {
                  const ganhos = dados.etapas['ganho'] || 0;
                  const conv = dados.total > 0 ? ((ganhos / dados.total) * 100).toFixed(0) : '0';
                  return (
                    <tr key={sdr} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                      onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafafa'}>
                      <td style={{ ...td, fontWeight: 600, color: '#0a1628' }}>{sdr}</td>
                      <td style={{ ...td, textAlign: 'center', fontWeight: 700 }}>{dados.total}</td>
                      {ETAPAS.map(e => (
                        <td key={e.key} style={{ ...td, textAlign: 'center' }}>
                          {dados.etapas[e.key] ? (
                            <span style={{ background: e.cor + '20', color: e.cor, borderRadius: 10, padding: '1px 8px', fontSize: 12, fontWeight: 600 }}>
                              {dados.etapas[e.key]}
                            </span>
                          ) : <span style={{ color: '#d1d5db' }}>—</span>}
                        </td>
                      ))}
                      <td style={{ ...td, textAlign: 'center' }}>
                        <span style={{ fontWeight: 700, color: Number(conv) >= 30 ? '#16a34a' : Number(conv) >= 10 ? '#f59e0b' : '#dc2626' }}>
                          {conv}%
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ background: '#f0f4ff', borderTop: '2px solid #c8d0da' }}>
                  <td style={{ ...td, fontWeight: 700, color: '#0a1628' }}>TOTAL</td>
                  <td style={{ ...td, textAlign: 'center', fontWeight: 700 }}>{totalGeral}</td>
                  {ETAPAS.map(e => {
                    const tot = filtradas.filter(op => op.etapa === e.key).length;
                    return (
                      <td key={e.key} style={{ ...td, textAlign: 'center', fontWeight: 700 }}>
                        {tot || <span style={{ color: '#d1d5db' }}>—</span>}
                      </td>
                    );
                  })}
                  <td style={{ ...td, textAlign: 'center', fontWeight: 700, color: '#8b5cf6' }}>{taxaConversao}%</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Aba: Clientes ── */
function RelatorioClientes() {
  const inpC = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [filtroSituacao, setFiltroSituacao] = useState('');
  const [ordenacao, setOrdenacao] = useState('resp_asc');
  // Visão POR PROCESSO é o padrão (pedido 26/08): uma linha por processo,
  // sem agrupar no cliente; 'cliente' mantém a visão antiga agrupada
  const [visaoLista, setVisaoLista] = useState('processo');
  const [loading, setLoading] = useState(true);
  const [excluindo, setExcluindo] = useState(null);
  const [confirmacao, setConfirmacao] = useState(null);
  const [excluirFinanceiro, setExcluirFinanceiro] = useState(false);

  const carregar = useCallback(async () => {
    setLoading(true);
    try { const data = await api.listarClientes(busca); setClientes(data); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [busca]);

  useEffect(() => { const t = setTimeout(carregar, 300); return () => clearTimeout(t); }, [carregar]);

  async function confirmarExclusao() {
    const { id } = confirmacao;
    const comFinanceiro = excluirFinanceiro;
    setConfirmacao(null);
    setExcluirFinanceiro(false);
    setExcluindo(id);
    try {
      const r = await api.deletarCliente(id, { excluirFinanceiro: comFinanceiro });
      setClientes(c => c.filter(x => x._id !== id));
      if (comFinanceiro) alert(`Cliente excluído. Removidos também: ${r.financeiro_removidos || 0} lançamento(s) do financeiro e ${r.vendas_removidas || 0} venda(s) do relatório.`);
    }
    catch (e) { alert(e.message); }
    finally { setExcluindo(null); }
  }

  // 1 linha por CLIENTE, com as marcas empilhadas (pós-unificação um cliente
  // tem várias marcas; o modelo antigo de rowSpan desalinhava ao ordenar)
  const procsDe = (c) => {
    const lista = Array.isArray(c.processos) ? c.processos : (c.processos ? [c.processos] : []);
    const out = lista.filter(p => p && (p.nome_marca || p.numero_processo));
    if (out.length === 0 && (c.nome_marca || c.numero_processo)) out.push({ nome_marca: c.nome_marca || '', numero_processo: c.numero_processo || '', situacao: c.situacao || '' });
    return [...out].sort((a, b) => (a.nome_marca || '').localeCompare(b.nome_marca || '', 'pt-BR'));
  };

  const situacoesUnicas = [...new Set(clientes.flatMap(c => procsDe(c).map(p => p.situacao).filter(Boolean)))].sort((a, b) => a.localeCompare(b, 'pt-BR'));

  const linhas = clientes
    .map(c => {
      const todos = procsDe(c);
      const procs = filtroSituacao ? todos.filter(p => p.situacao === filtroSituacao) : todos;
      return { ...c, _procs: procs, _totalProcs: todos.length, _ident: (c.responsavel || c.nome || c.razao_social || '').trim() };
    })
    .filter(l => !filtroSituacao || l._procs.length > 0)
    .sort((a, b) => {
      const pa = a._procs[0] || {}, pb = b._procs[0] || {};
      if (ordenacao === 'resp_asc') return (a._ident || 'zzz').localeCompare(b._ident || 'zzz', 'pt-BR');
      if (ordenacao === 'marca_asc') return (pa.nome_marca || 'zzz').localeCompare(pb.nome_marca || 'zzz', 'pt-BR');
      if (ordenacao === 'marca_desc') return (pb.nome_marca || '').localeCompare(pa.nome_marca || '', 'pt-BR');
      if (ordenacao === 'mais_marcas') return b._totalProcs - a._totalProcs;
      return 0;
    });

  return (
    <div>
      {confirmacao && (
        <ModalConfirmar
          mensagem={`Tem certeza que deseja excluir o cliente "${confirmacao.nome}"? Esta ação não pode ser desfeita.`}
          extra={
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '10px 12px', cursor: 'pointer' }}>
              <input type="checkbox" checked={excluirFinanceiro} onChange={e => setExcluirFinanceiro(e.target.checked)} style={{ marginTop: 2 }} />
              <span style={{ fontSize: 13, color: '#374151', lineHeight: 1.4 }}>
                <strong>Excluir também as informações financeiras</strong><br />
                <span style={{ fontSize: 12, color: '#6b7280' }}>Apaga os lançamentos do Contas a Receber/Pagar e as vendas do relatório deste cliente. Desmarcado, o financeiro é mantido.</span>
              </span>
            </label>
          }
          onConfirmar={confirmarExclusao}
          onCancelar={() => { setConfirmacao(null); setExcluirFinanceiro(false); }}
        />
      )}

      <div style={{ marginBottom: 10, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 13, color: '#6b7280' }}>
          <strong style={{ color: '#0a1628' }}>{linhas.length}</strong>{linhas.length !== clientes.length ? ` de ${clientes.length}` : ''} cliente(s)
          · <strong style={{ color: '#0a1628' }}>{clientes.reduce((s, c) => s + procsDe(c).length, 0)}</strong> marcas/processos
        </span>
        {/* Alternador de visão + exportação */}
        <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {[['processo', '🧾 Por processo'], ['cliente', '👥 Por cliente']].map(([v, rot]) => (
            <button key={v} onClick={() => setVisaoLista(v)}
              style={{ background: visaoLista === v ? '#0a1628' : '#fff', color: visaoLista === v ? '#fff' : '#374151', border: '1px solid ' + (visaoLista === v ? '#0a1628' : '#c8d0da'), borderRadius: 6, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              {rot}
            </button>
          ))}
          <span style={{ width: 1, height: 20, background: '#dbe2ea' }} />
          {[['excel', '📊 Excel', '#1d6f42'], ['pdf', '📄 PDF', '#b91c1c']].map(([fmt, rot, cor]) => (
            <button key={fmt} onClick={async () => {
              try {
                const r = await fetch(`/clientes/export-lista/${fmt}`, { headers: { Authorization: `Bearer ${token()}` } });
                if (!r.ok) throw new Error('falha na geração');
                const blob = await r.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url; a.download = `lista_clientes.${fmt === 'excel' ? 'xlsx' : 'pdf'}`;
                document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
              } catch (e) { alert('Exportação falhou: ' + e.message); }
            }}
              style={{ background: cor, color: '#fff', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
              {rot}
            </button>
          ))}
        </span>
      </div>

      <div style={{ marginBottom: 10, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <input value={busca} onChange={e => setBusca(e.target.value)}
          placeholder="Buscar por nome, CPF, CNPJ, marca ou processo..."
          style={{ ...inpC, maxWidth: 340, flex: 1 }} />
        <select value={filtroSituacao} onChange={e => setFiltroSituacao(e.target.value)} style={{ ...inpC, minWidth: 180, height: 26 }}>
          <option value="">Todas as situações</option>
          {situacoesUnicas.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={ordenacao} onChange={e => setOrdenacao(e.target.value)} style={{ ...inpC, minWidth: 180, height: 26 }}>
          <option value="resp_asc">Cliente A → Z</option>
          <option value="marca_asc">Marca A → Z</option>
          <option value="marca_desc">Marca Z → A</option>
          <option value="mais_marcas">Mais marcas primeiro</option>
        </select>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
      ) : clientes.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', color: '#6b7280', fontSize: 13 }}>
          <p style={{ fontWeight: 500 }}>{busca ? 'Nenhum resultado encontrado' : 'Nenhum cliente cadastrado'}</p>
        </div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 6, overflowX: 'auto', background: '#fff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {visaoLista === 'processo' ? (<>
                  <th style={{ ...th, width: 130 }}>Nº Processo</th>
                  <th style={th}>Marca</th>
                  <th style={{ ...th, width: 220 }}>Cliente</th>
                  <th style={{ ...th, width: 140 }}>Telefone</th>
                  <th style={{ ...th, width: 150 }}>Ações</th>
                </>) : (<>
                  <th style={{ ...th, width: 220 }}>Cliente</th>
                  <th style={th}>Marcas / Processos</th>
                  <th style={{ ...th, width: 140 }}>Telefone</th>
                  <th style={{ ...th, width: 150 }}>Ações</th>
                </>)}
              </tr>
            </thead>
            <tbody>
              {visaoLista === 'processo' ? linhas.flatMap(c => (c._procs.length ? c._procs.map(p => ({ c, p })) : [{ c, p: null }])).map(({ c, p }, i) => (
                <tr key={c._id + '|' + (p?.numero_processo || 'sem') + '|' + i}
                  style={{ background: i % 2 === 0 ? '#fff' : '#fafbfc' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafbfc'}>
                  <td style={{ ...td, padding: '7px 10px', fontFamily: 'monospace', fontSize: 12, whiteSpace: 'nowrap' }}>{p?.numero_processo || '—'}</td>
                  <td style={{ ...td, padding: '7px 10px' }}>
                    <span style={{ fontWeight: 600, color: '#111', fontSize: 12.5 }}>{p?.nome_marca || <em style={{ color: '#9ca3af', fontWeight: 400 }}>(sem marca)</em>}</span>
                    {p?.situacao && (
                      <span style={{ marginLeft: 8, fontSize: 10, fontWeight: 600, borderRadius: 4, padding: '0 6px', background: /vigor|concedid/i.test(p.situacao) ? '#dcfce7' : /arquiv|extin|indefer|nulidade/i.test(p.situacao) ? '#fee2e2' : '#f3f4f6', color: /vigor|concedid/i.test(p.situacao) ? '#15803d' : /arquiv|extin|indefer|nulidade/i.test(p.situacao) ? '#991b1b' : '#6b7280' }}>
                        {p.situacao}
                      </span>
                    )}
                  </td>
                  <td style={{ ...td, padding: '7px 10px', fontWeight: 700, color: '#0a1628', fontSize: 12.5 }}>{c._ident || '—'}</td>
                  <td style={{ ...td, padding: '7px 10px', whiteSpace: 'nowrap' }}>{c.telefone || '—'}</td>
                  <td style={{ ...td, padding: '7px 10px' }}>
                    <Link to={`/clientes/${c._id}/editar`}>
                      <button style={{ background: '#0a1628', color: '#fff', border: 'none', padding: '3px 12px', fontSize: 11, fontWeight: 600, borderRadius: 5, cursor: 'pointer' }}>Visualizar</button>
                    </Link>
                  </td>
                </tr>
              )) : linhas.map((c, i) => (
                <tr key={c._id}
                  style={{ background: i % 2 === 0 ? '#fff' : '#fafbfc', verticalAlign: 'top' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafbfc'}>
                  <td style={{ ...td, padding: '8px 10px' }}>
                    <div style={{ fontWeight: 700, color: '#0a1628', fontSize: 13 }}>{c._ident || '—'}</div>
                    {c._totalProcs > 1 && (
                      <span style={{ display: 'inline-block', marginTop: 3, fontSize: 10, fontWeight: 700, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 99, padding: '1px 8px' }}>
                        {c._totalProcs} marcas
                      </span>
                    )}
                  </td>
                  <td style={{ ...td, padding: '8px 10px' }}>
                    {c._procs.length === 0 ? <span style={{ color: '#9ca3af' }}>—</span> : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        {c._procs.map((p, k) => (
                          <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <span style={{ fontWeight: 600, color: '#111', fontSize: 12.5 }}>{p.nome_marca || <em style={{ color: '#9ca3af', fontWeight: 400 }}>(sem marca)</em>}</span>
                            {p.numero_processo && <span style={{ fontFamily: 'monospace', fontSize: 11.5, color: '#6b7280' }}>{p.numero_processo}</span>}
                            {p.situacao && (
                              <span style={{ fontSize: 10, fontWeight: 600, borderRadius: 4, padding: '0 6px', background: /registro de marca em vigor|vigor|concedid/i.test(p.situacao) ? '#dcfce7' : /arquiv|extin|indefer|nulidade/i.test(p.situacao) ? '#fee2e2' : '#f3f4f6', color: /registro de marca em vigor|vigor|concedid/i.test(p.situacao) ? '#15803d' : /arquiv|extin|indefer|nulidade/i.test(p.situacao) ? '#991b1b' : '#6b7280' }}>
                                {p.situacao}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </td>
                  <td style={{ ...td, padding: '8px 10px', whiteSpace: 'nowrap' }}>{c.telefone || '—'}</td>
                  <td style={{ ...td, padding: '8px 10px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <Link to={`/clientes/${c._id}/editar`}>
                        <button style={{ background: '#0a1628', color: '#fff', border: 'none', padding: '3px 12px', fontSize: 11, fontWeight: 600, borderRadius: 5, cursor: 'pointer' }}>Visualizar</button>
                      </Link>
                      {ehVagner() && (
                        <button onClick={() => setConfirmacao({ id: c._id, nome: c._ident || c.nome })} disabled={excluindo === c._id}
                          style={{ background: '#fff', color: '#dc2626', border: '1px solid #fecaca', padding: '3px 10px', fontSize: 11, borderRadius: 5, cursor: 'pointer' }}>
                          {excluindo === c._id ? '...' : 'Excluir'}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

/* ── Abas disponíveis ── */
/* ── Aba: Vendas (gravadas pelo botão Gravar Cliente do CRM) ── */
// ── Modal: cadastro de serviços (catálogo) — lista os já existentes ──
function ModalCadastroServicos({ onFechar }) {
  const [servicos, setServicos] = useState(null);
  const [nome, setNome] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const carregar = () => apiFetch('/oportunidades/servicos-catalogo')
    .then(d => setServicos(d.servicos || []))
    .catch(() => setServicos([]));
  useEffect(() => { carregar(); }, []);

  async function adicionar() {
    if (!nome.trim()) return setErro('Digite o nome do serviço.');
    setSalvando(true); setErro('');
    try {
      const r = await apiFetch('/oportunidades/servicos-catalogo', { method: 'POST', body: JSON.stringify({ nome: nome.trim() }) });
      if (r.erro) throw new Error(r.erro);
      setNome('');
      carregar();
    } catch (e) { setErro(e.message); }
    setSalvando(false);
  }

  async function excluir(s) {
    if (!window.confirm(`Excluir o serviço "${s.nome}" do catálogo?`)) return;
    await apiFetch(`/oportunidades/servicos-catalogo/${s._id}`, { method: 'DELETE' }).catch(() => {});
    carregar();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 480, maxWidth: '94%', maxHeight: '85vh', overflowY: 'auto', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>⚙️ Cadastro de serviços</h2>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280', lineHeight: 1 }}>×</button>
        </div>
        <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 12px' }}>Os serviços daqui aparecem no seletor de categoria do Gravar Cliente. Os marcados "em uso" vieram das vendas já lançadas.</p>
        <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
          <input value={nome} onChange={e => { setNome(e.target.value); setErro(''); }} onKeyDown={e => { if (e.key === 'Enter') adicionar(); }}
            placeholder="Nome do novo serviço… (ex: Patente)" autoFocus style={{ ...inp, flex: 1 }} />
          <button onClick={adicionar} disabled={salvando} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            {salvando ? '…' : '➕ Adicionar'}
          </button>
        </div>
        {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}
        {!servicos ? (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: 16, fontSize: 13 }}>Carregando…</div>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8 }}>
            {servicos.map((s, i) => (
              <div key={s._id || s.nome} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', borderBottom: i < servicos.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: '#0a1628' }}>{s.nome}</span>
                {s.origem === 'vendas'
                  ? <span title="Apareceu nas vendas já lançadas — faz parte do histórico" style={{ fontSize: 10, fontWeight: 700, color: '#0369a1', background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 4, padding: '0 6px' }}>em uso nas vendas</span>
                  : <button onClick={() => excluir(s)} title="Excluir do catálogo" style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 13, cursor: 'pointer', padding: '0 4px' }}>🗑</button>}
              </div>
            ))}
            {servicos.length === 0 && <div style={{ padding: 14, fontSize: 12.5, color: '#9ca3af', textAlign: 'center' }}>Nenhum serviço ainda.</div>}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Mini-gráficos dos relatórios: divs e SVG puros, sem biblioteca ──────────
const CORES_GRAF = ['#1d4ed8', '#15803d', '#d97706', '#7c3aed', '#dc2626', '#0891b2', '#be185d', '#65a30d', '#0a1628', '#6b7280'];
const MESES_ABREV = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
const abreviaValor = (v) => PRIVADO ? '•••'
  : v >= 1000000 ? `${(v / 1000000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mi`
    : v >= 1000 ? `${(v / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`
      : String(Math.round(v));

// flexo: proporção da caixa na linha (2 = duas vezes mais larga que as de 1)
const CaixaGraf = ({ titulo, children, minWidth = 300, flexo = 1 }) => (
  <div style={{ flex: flexo, minWidth, background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, padding: '10px 14px' }}>
    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>{titulo}</div>
    {children}
  </div>
);

// Donut SVG com legenda — dados: [[rotulo, valor]]
function GrafDonut({ titulo, dados, formato = abreviaValor }) {
  const total = dados.reduce((s, [, v]) => s + v, 0);
  if (!total) return null;
  const cx = 60, cy = 60, R = 54, r = 32;
  let ang = -Math.PI / 2;
  const fatias = dados.filter(([, v]) => v > 0).map(([rotulo, v], i) => {
    const frac = v / total;
    const a0 = ang, a1 = ang + frac * 2 * Math.PI;
    ang = a1;
    const p = (a, rr) => `${(cx + rr * Math.cos(a)).toFixed(2)},${(cy + rr * Math.sin(a)).toFixed(2)}`;
    const grande = frac > 0.5 ? 1 : 0;
    return {
      rotulo, v, frac, cor: CORES_GRAF[i % CORES_GRAF.length],
      d: `M ${p(a0, R)} A ${R} ${R} 0 ${grande} 1 ${p(a1, R)} L ${p(a1, r)} A ${r} ${r} 0 ${grande} 0 ${p(a0, r)} Z`,
    };
  });
  return (
    <CaixaGraf titulo={titulo}>
      <div style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap' }}>
        <svg width={120} height={120} role="img">
          {/* fatia única não fecha um path de arco — vira anel cheio */}
          {fatias.length === 1
            ? <circle cx={cx} cy={cy} r={(R + r) / 2} fill="none" stroke={fatias[0].cor} strokeWidth={R - r} />
            : fatias.map((f, i) => <path key={i} d={f.d} fill={f.cor}><title>{`${f.rotulo}: ${formato(f.v)} (${Math.round(f.frac * 100)}%)`}</title></path>)}
        </svg>
        <div style={{ flex: 1, minWidth: 140 }}>
          {fatias.map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 3 }}>
              <span style={{ width: 10, height: 10, borderRadius: 2, background: f.cor, flexShrink: 0 }} />
              <span style={{ flex: 1, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={f.rotulo}>{f.rotulo}</span>
              <b style={{ color: '#0a1628' }}>{Math.round(f.frac * 100)}%</b>
            </div>
          ))}
        </div>
      </div>
    </CaixaGraf>
  );
}

// Barras dos 12 meses; clicar num mês aplica o mesmo filtro dos botões de mês
// fantasma (opcional): valores de comparação exibidos em cinza tracejado nos
// meses em que a série principal está zerada — não somam em nada, só situam
function GrafMeses({ titulo, valores, mesSel, onMes, formato = abreviaValor, fantasma, notaFantasma, flexo, minWidth }) {
  const max = Math.max(...valores, ...(fantasma || []), 1);
  const temFantasma = fantasma && fantasma.some((f, k) => f > 0 && !valores[k]);
  return (
    <CaixaGraf titulo={titulo} flexo={flexo} minWidth={minWidth}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4 }}>
        {valores.map((v, k) => {
          const ativo = mesSel === String(k + 1);
          const gh = (!v && fantasma && fantasma[k] > 0) ? fantasma[k] : 0;
          const val = v || gh;
          return (
            <div key={k} onClick={() => onMes && onMes(ativo ? '' : String(k + 1))}
              title={`${MESES_ABREV[k]}: ${formato(val)}${gh ? ' — Faturamento Geral (sem vendas no sistema)' : ''}`}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: onMes ? 'pointer' : 'default', opacity: mesSel && !ativo ? 0.45 : 1 }}>
              <div style={{ fontSize: 9, color: gh ? '#94a3b8' : '#6b7280', fontStyle: gh ? 'italic' : 'normal', marginBottom: 2, whiteSpace: 'nowrap' }}>{val > 0 ? formato(val) : ''}</div>
              <div style={{ width: '78%', height: Math.max(val > 0 ? 4 : 1, Math.round(val / max * 80)), boxSizing: 'border-box',
                background: gh ? '#e2e8f0' : ativo ? '#0a1628' : '#1d4ed8',
                border: gh ? '1.5px dashed #94a3b8' : 'none', borderBottom: 'none',
                borderRadius: '3px 3px 0 0' }} />
              <div style={{ fontSize: 9.5, fontWeight: ativo ? 700 : 400, color: ativo ? '#0a1628' : '#6b7280', marginTop: 3 }}>{MESES_ABREV[k]}</div>
            </div>
          );
        })}
      </div>
      {temFantasma && notaFantasma && (
        <div style={{ fontSize: 10.5, color: '#94a3b8', marginTop: 8 }}>
          <span style={{ display: 'inline-block', width: 10, height: 10, background: '#e2e8f0', border: '1.5px dashed #94a3b8', borderRadius: 2, verticalAlign: '-1px', marginRight: 5 }} />
          {notaFantasma}
        </div>
      )}
    </CaixaGraf>
  );
}

// Meses empilhados por categoria — dados[k] = { categoria: itens }
function GrafMesesEmpilhado({ titulo, categorias, dados, mesSel, onMes }) {
  const totais = dados.map(m => categorias.reduce((s, c) => s + (m[c] || 0), 0));
  const max = Math.max(...totais, 1);
  return (
    <CaixaGraf titulo={titulo}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4 }}>
        {dados.map((m, k) => {
          const ativo = mesSel === String(k + 1);
          return (
            <div key={k} onClick={() => onMes && onMes(ativo ? '' : String(k + 1))} title={`${MESES_ABREV[k]}: ${totais[k]} itens`}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', opacity: mesSel && !ativo ? 0.5 : 1 }}>
              <div style={{ fontSize: 9, color: '#6b7280', marginBottom: 2 }}>{totais[k] || ''}</div>
              <div style={{ width: '78%', display: 'flex', flexDirection: 'column-reverse', borderRadius: '3px 3px 0 0', overflow: 'hidden' }}>
                {categorias.map((c, i) => {
                  const h = Math.round((m[c] || 0) / max * 80);
                  return h > 0 ? <div key={c} style={{ height: h, background: CORES_GRAF[i % CORES_GRAF.length] }} /> : null;
                })}
              </div>
              <div style={{ fontSize: 9.5, fontWeight: ativo ? 700 : 400, color: '#6b7280', marginTop: 3 }}>{MESES_ABREV[k]}</div>
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 8 }}>
        {categorias.map((c, i) => (
          <span key={c} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#374151' }}>
            <span style={{ width: 9, height: 9, borderRadius: 2, background: CORES_GRAF[i % CORES_GRAF.length] }} />{c}
          </span>
        ))}
      </div>
    </CaixaGraf>
  );
}

// Barras horizontais — linhas: [[rotulo, valor]]
function GrafBarrasH({ titulo, linhas, formato = abreviaValor }) {
  const max = Math.max(...linhas.map(([, v]) => v), 1);
  if (!linhas.length) return null;
  return (
    <CaixaGraf titulo={titulo}>
      {linhas.map(([rotulo, v], i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
          <span style={{ width: 150, fontSize: 12, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'right' }} title={rotulo}>{rotulo}</span>
          <div style={{ flex: 1, background: '#f1f5f9', borderRadius: 3, height: 16 }}>
            <div style={{ width: `${Math.max(2, Math.round(v / max * 100))}%`, height: '100%', background: CORES_GRAF[i % CORES_GRAF.length], borderRadius: 3 }} />
          </div>
          <b style={{ fontSize: 12, color: '#0a1628', minWidth: 60, textAlign: 'right', whiteSpace: 'nowrap' }}>{formato(v)}</b>
        </div>
      ))}
    </CaixaGraf>
  );
}

// ── Relatório de Serviços: o que foi vendido, agrupado — o foco é a
// QUANTIDADE de itens por tipo (ex.: quantos registros de marca no mês)
function RelatorioServicos() {
  const hoje = new Date();
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ano, setAno] = useState(String(hoje.getFullYear()));
  const [mes, setMes] = useState(String(hoje.getMonth() + 1));
  const [consultor, setConsultor] = useState('');
  const [modalCadastro, setModalCadastro] = useState(false);

  useEffect(() => {
    apiFetch('/oportunidades/vendas')
      .then(d => setVendas(d.vendas || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const consultores = [...new Set(vendas.map(v => v.consultor).filter(Boolean))].sort();
  const filtradas = vendas.filter(v => {
    if (ano && v.data_venda.slice(0, 4) !== ano) return false;
    if (mes && v.data_venda.slice(5, 7) !== String(mes).padStart(2, '0')) return false;
    if (consultor && v.consultor !== consultor) return false;
    return true;
  });
  const moedaBR = (n) => PRIVADO ? 'R$ •••' : `R$ ${(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
  const qtd = (v) => Math.max(1, parseInt(v.quantidade) || 1);

  // Agrupamento por categoria (visão geral) e por serviço (detalhe)
  const agrupar = (chaveFn) => {
    const m = new Map();
    for (const v of filtradas) {
      const k = chaveFn(v) || '(sem informação)';
      const g = m.get(k) || { vendas: 0, itens: 0, valor: 0 };
      g.vendas += 1; g.itens += qtd(v); g.valor += v.valor;
      m.set(k, g);
    }
    return [...m.entries()].sort((a, b) => b[1].itens - a[1].itens || b[1].valor - a[1].valor);
  };
  const porCategoria = agrupar(v => v.categoria);
  const porServico = agrupar(v => (v.servico || '').trim());
  const totalItens = filtradas.reduce((s, v) => s + qtd(v), 0);
  const totalValor = filtradas.reduce((s, v) => s + v.valor, 0);

  // Evolução mensal por categoria: o ano inteiro (ignora o filtro de mês),
  // com as 6 maiores categorias nomeadas e o resto agrupado em 'Outros'
  const doAnoS = vendas.filter(v => (!ano || v.data_venda.slice(0, 4) === ano) && (!consultor || v.consultor === consultor));
  const totCat = new Map();
  for (const v of doAnoS) { const c = v.categoria || '(sem)'; totCat.set(c, (totCat.get(c) || 0) + qtd(v)); }
  const catsTop = [...totCat.entries()].sort((a, b) => b[1] - a[1]).slice(0, 6).map(([c]) => c);
  const dadosMes = Array.from({ length: 12 }, (_, k) => {
    const o = {};
    for (const v of doAnoS) {
      if (v.data_venda.slice(5, 7) !== String(k + 1).padStart(2, '0')) continue;
      const c = catsTop.includes(v.categoria || '(sem)') ? (v.categoria || '(sem)') : 'Outros';
      o[c] = (o[c] || 0) + qtd(v);
    }
    return o;
  });
  const catsGraf = [...catsTop, ...(dadosMes.some(m => m.Outros) ? ['Outros'] : [])];
  // Preço médio praticado = valor vendido ÷ itens (capta o desconto médio real)
  const precoMedio = porServico.slice(0, 10).map(([nome, g]) => [nome, g.itens ? g.valor / g.itens : 0]);

  const Tabela = ({ titulo, linhas, rotulo }) => (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', margin: '0 0 6px' }}>{titulo}</div>
      <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
          <thead>
            <tr>{[rotulo, 'Vendas', 'Itens', 'Valor', '% do valor'].map((h, i) => <th key={i} style={{ ...th, textAlign: i === 0 ? 'left' : i >= 3 ? 'right' : 'center' }}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {linhas.map(([nome, g], i) => (
              <tr key={nome} style={{ background: i % 2 ? '#fafafa' : '#fff' }}>
                <td style={td}>{nome}</td>
                <td style={{ ...td, textAlign: 'center' }}>{nPriv(g.vendas)}</td>
                <td style={{ ...td, textAlign: 'center', fontWeight: 700, color: '#0a1628' }}>{nPriv(g.itens)}</td>
                <td style={{ ...td, textAlign: 'right', fontWeight: 600, color: '#15803d', whiteSpace: 'nowrap' }}>{moedaBR(g.valor)}</td>
                <td style={{ ...td, textAlign: 'right', color: '#6b7280', whiteSpace: 'nowrap' }}>{totalValor ? Math.round(g.valor / totalValor * 100) : 0}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>Ano:</span>
          <select value={ano} onChange={e => setAno(e.target.value)} style={{ ...inp, minWidth: 100, fontWeight: 600 }}>
            {Array.from({ length: 2040 - 2022 + 1 }, (_, k) => 2022 + k).map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          {['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'].map((nome, k) => {
            const m = String(k + 1);
            const ativo = mes === m;
            return (
              <button key={k} onClick={() => setMes(ativo ? '' : m)} style={{
                flex: 1, padding: '4px 0', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer',
                border: '1px solid ' + (ativo ? '#0a1628' : '#c8d0da'),
                background: ativo ? '#0a1628' : '#fff', color: ativo ? '#fff' : '#374151',
              }}>{nome}</button>
            );
          })}
        </div>
        {mes && <div style={{ textAlign: 'center' }}><button onClick={() => setMes('')} style={{ ...inp, cursor: 'pointer', color: '#6b7280' }}>ver o ano todo</button></div>}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        {ehVagner() ? (
          <select value={consultor} onChange={e => setConsultor(e.target.value)} style={{ ...inp, minWidth: 180 }}>
            <option value="">Consultor: todos</option>
            {consultores.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        ) : (
          <span style={{ fontSize: 12, fontWeight: 600, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '4px 10px' }}>
            Mostrando apenas os seus serviços
          </span>
        )}
        {ehVagner() && (
          <button onClick={() => setModalCadastro(true)} title="Cadastrar serviços novos e ver os existentes"
            style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', marginLeft: 'auto' }}>
            ⚙️ Cadastrar serviços
          </button>
        )}
      </div>
      {modalCadastro && <ModalCadastroServicos onFechar={() => setModalCadastro(false)} />}

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
        {[
          { label: 'Itens vendidos', valor: nPriv(totalItens), cor: '#0a1628' },
          { label: 'Vendas', valor: nPriv(filtradas.length), cor: '#1d4ed8' },
          { label: 'Valor total', valor: moedaBR(totalValor), cor: '#15803d' },
        ].map((m, i) => (
          <div key={i} style={{ background: '#f9fafb', borderRadius: 10, padding: '10px 14px', flex: 1, minWidth: 130 }}>
            <div style={{ fontSize: 11, color: '#6b7280' }}>{m.label}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: m.cor, marginTop: 2 }}>{m.valor}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
      ) : filtradas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 30, background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', color: '#6b7280', fontSize: 13 }}>
          Nenhuma venda no período/filtro.
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
            <GrafBarrasH titulo="Itens vendidos por serviço" linhas={porServico.slice(0, 10).map(([n, g]) => [n, g.itens])} formato={v => String(v)} />
            <GrafDonut titulo="Participação no valor por categoria" dados={porCategoria.map(([n, g]) => [n, g.valor])} formato={moedaBR} />
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
            <GrafMesesEmpilhado titulo={`Itens por categoria mês a mês (${ano})`} categorias={catsGraf} dados={dadosMes} mesSel={mes} onMes={setMes} />
            <GrafBarrasH titulo="Preço médio praticado por serviço" linhas={precoMedio} formato={moedaBR} />
          </div>
          <Tabela titulo="Por categoria" linhas={porCategoria} rotulo="Categoria" />
          <Tabela titulo="Por serviço (detalhe)" linhas={porServico} rotulo="Serviço" />
        </>
      )}
    </div>
  );
}

// ── Comissões dos closers POR LIQUIDAÇÃO: a base do mês é o que o cliente
// PAGOU no mês (parcela quitada), não o que foi vendido — boleto parcelado
// gera comissão parcela a parcela. % vem do cadastro do usuário.
function RelatorioComissoes() {
  const hoje = new Date();
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ano, setAno] = useState(String(hoje.getFullYear()));
  const [mes, setMes] = useState(String(hoje.getMonth() + 1));
  const [aberto, setAberto] = useState(''); // consultor com o detalhe expandido

  useEffect(() => {
    setLoading(true);
    apiFetch(`/financeiro/comissoes?ano=${ano}&mes=${mes}`)
      .then(setDados).catch(() => setDados(null))
      .finally(() => setLoading(false));
  }, [ano, mes]);

  const moedaBR = (n) => PRIVADO ? 'R$ •••' : `R$ ${(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
  const fmtBR = (iso) => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—';
  const linhas = dados?.linhas || [];

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>Ano:</span>
          <select value={ano} onChange={e => setAno(e.target.value)} style={{ ...inp, minWidth: 100, fontWeight: 600 }}>
            {Array.from({ length: 2040 - 2022 + 1 }, (_, k) => 2022 + k).map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          {['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'].map((nome, k) => {
            const m = String(k + 1);
            const ativo = mes === m;
            return (
              <button key={k} onClick={() => setMes(ativo ? '' : m)} style={{
                flex: 1, padding: '4px 0', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer',
                border: '1px solid ' + (ativo ? '#0a1628' : '#c8d0da'),
                background: ativo ? '#0a1628' : '#fff', color: ativo ? '#fff' : '#374151',
              }}>{nome}</button>
            );
          })}
        </div>
      </div>

      {dados?.restrito && (
        <div style={{ marginBottom: 10 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '4px 10px' }}>
            Mostrando apenas as suas comissões
          </span>
        </div>
      )}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
        {[
          { label: dados?.restrito ? 'Você liquidou no período' : 'Liquidado no período (com closer)', valor: moedaBR(dados?.totais?.recebido), cor: '#15803d' },
          { label: dados?.restrito ? 'Sua comissão' : 'Total de comissões', valor: moedaBR(dados?.totais?.comissao), cor: '#7c3aed' },
        ].map((m, i) => (
          <div key={i} style={{ background: '#f9fafb', borderRadius: 10, padding: '10px 14px', flex: 1, minWidth: 160 }}>
            <div style={{ fontSize: 11, color: '#6b7280' }}>{m.label}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: m.cor, marginTop: 2 }}>{m.valor}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
      ) : linhas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 30, background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', color: '#6b7280', fontSize: 13 }}>
          Nenhuma liquidação com closer no período. A comissão nasce quando uma parcela de venda é PAGA (baixa no Contas a Receber).
        </div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
            <thead>
              <tr>{['Closer', '% comissão', 'Vendido no período', 'Liquidado no período', 'Comissão a pagar', ''].map((h, i) => (
                <th key={i} style={{ ...th, textAlign: i >= 2 && i <= 4 ? 'right' : 'left' }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {linhas.map((l) => (
                <React.Fragment key={l.consultor}>
                  <tr onClick={() => setAberto(a => a === l.consultor ? '' : l.consultor)} style={{ cursor: 'pointer', borderBottom: '1px solid #e8eaed' }}
                    title="Clique para ver as parcelas liquidadas que compõem a comissão">
                    <td style={{ ...td, fontWeight: 700 }}>{aberto === l.consultor ? '▾' : '▸'} {l.consultor}</td>
                    <td style={td}>{l.pct ? `${l.pct}%` : (dados?.restrito ? <span style={{ color: '#9ca3af' }}>a definir</span> : <span style={{ color: '#dc2626', fontWeight: 600 }}>defina no cadastro</span>)}</td>
                    <td style={{ ...td, textAlign: 'right', color: '#6b7280', whiteSpace: 'nowrap' }}>{moedaBR(l.vendido)}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 600, color: '#15803d', whiteSpace: 'nowrap' }}>{moedaBR(l.recebido)}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: '#7c3aed', whiteSpace: 'nowrap' }}>{moedaBR(l.comissao)}</td>
                    <td style={td}>{l.parcelas.length} parcela{l.parcelas.length !== 1 ? 's' : ''}</td>
                  </tr>
                  {aberto === l.consultor && l.parcelas.map((p, i) => (
                    <tr key={i} style={{ background: '#f8fafc', borderBottom: '1px solid #eef2f7' }}>
                      <td style={{ ...td, paddingLeft: 26, color: '#374151' }} colSpan={2}>{p.cliente || '—'} · {p.descricao}</td>
                      <td style={{ ...td, textAlign: 'right', color: '#6b7280' }}>pago em {fmtBR(p.data_pagamento)}</td>
                      <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>{moedaBR(p.valor)}</td>
                      <td style={{ ...td, textAlign: 'right', color: '#7c3aed', whiteSpace: 'nowrap' }}>{moedaBR(p.valor * l.pct / 100)}</td>
                      <td style={td}></td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 8 }}>
        Comissão por <b>liquidação</b>: parcela paga dentro do período gera comissão naquele mês, mesmo de venda antiga. Venda sem baixa ainda não gera.{dados?.restrito ? '' : ' O % é definido em Configurações → Usuários.'}
      </div>
    </div>
  );
}

function RelatorioVendas() {
  const hoje = new Date();
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ano, setAno] = useState(String(hoje.getFullYear()));
  const [mes, setMes] = useState(String(hoje.getMonth() + 1));
  const [consultor, setConsultor] = useState('');
  const [servico, setServico] = useState('');

  useEffect(() => {
    apiFetch('/oportunidades/vendas')
      .then(d => setVendas(d.vendas || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Faturamento Geral (a tabela histórica): completa os meses SEM venda do
  // gráfico, só pra comparação visual — não entra em total, ticket nem tabela
  const [fatGeral, setFatGeral] = useState(null);
  useEffect(() => {
    apiFetch('/financeiro/faturamento-geral').then(d => setFatGeral(d.anos || d)).catch(() => {});
  }, []);

  const consultores = [...new Set(vendas.map(v => v.consultor).filter(Boolean))].sort();

  const filtradas = vendas.filter(v => {
    if (ano && v.data_venda.slice(0, 4) !== ano) return false;
    if (mes && v.data_venda.slice(5, 7) !== String(mes).padStart(2, '0')) return false;
    if (consultor && v.consultor !== consultor) return false;
    if (servico && !(`${v.servico} ${v.categoria}`).toLowerCase().includes(servico.trim().toLowerCase())) return false;
    return true;
  });
  const totalValor = filtradas.reduce((s, v) => s + v.valor, 0);
  const moedaBR = (n) => PRIVADO ? 'R$ •••' : `R$ ${(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
  const fmtBR = (iso) => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—';

  // Nº de PEDIDOS: venda multi-produto vira uma linha por item, todas com o
  // mesmo grupo_parcelas — contar linhas inflava vendas e derrubava o ticket
  const nPedidos = new Set(filtradas.map(v => v.grupo_parcelas || v.id)).size;

  // Mesmos filtros SEM o mês: alimentam a evolução anual e o comparativo
  const passaBase = (v, anoRef) => v.data_venda.slice(0, 4) === String(anoRef)
    && (!consultor || v.consultor === consultor)
    && (!servico || (`${v.servico} ${v.categoria}`).toLowerCase().includes(servico.trim().toLowerCase()));
  const doAno = vendas.filter(v => passaBase(v, ano));
  const porMesValor = Array.from({ length: 12 }, (_, k) =>
    doAno.filter(v => v.data_venda.slice(5, 7) === String(k + 1).padStart(2, '0')).reduce((s, v) => s + v.valor, 0));
  // Fantasmas do gráfico: valor do Faturamento Geral nos meses sem venda
  // (só aparecem sem filtro de consultor/serviço — o histórico não tem esses recortes)
  const anoFat = Array.isArray(fatGeral) ? fatGeral.find(a => String(a.ano) === String(ano)) : null;
  const porMesGeral = (!consultor && !servico && anoFat)
    ? Array.from({ length: 12 }, (_, k) => anoFat.meses?.find(x => x.mes === k + 1)?.fatura || 0)
    : null;

  // Comparativo: mês selecionado × mês anterior; ano inteiro × ano anterior
  let comparativo = null;
  if (mes) {
    let a = +ano, m = +mes - 1;
    if (m === 0) { m = 12; a -= 1; }
    const antes = vendas.filter(v => passaBase(v, a) && v.data_venda.slice(5, 7) === String(m).padStart(2, '0')).reduce((s, v) => s + v.valor, 0);
    if (antes > 0) comparativo = { rotulo: 'vs mês anterior', delta: (totalValor - antes) / antes };
  } else {
    const antes = vendas.filter(v => passaBase(v, +ano - 1)).reduce((s, v) => s + v.valor, 0);
    if (antes > 0) comparativo = { rotulo: `vs ${+ano - 1}`, delta: (totalValor - antes) / antes };
  }

  // Mix de pagamento sobre o período filtrado
  const porForma = [...filtradas.reduce((m, v) => {
    const k = v.forma_pagamento || '(sem forma)';
    m.set(k, (m.get(k) || 0) + v.valor); return m;
  }, new Map()).entries()].sort((a, b) => b[1] - a[1]);
  const valorParcelado = filtradas.filter(v => v.num_parcelas > 1).reduce((s, v) => s + v.valor, 0);
  const pedidosParcelados = new Set(filtradas.filter(v => v.num_parcelas > 1).map(v => v.grupo_parcelas || v.id)).size;

  return (
    <div>
      {/* Filtro de tempo (estilo Financeiro) */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>Ano:</span>
          <select value={ano} onChange={e => setAno(e.target.value)} style={{ ...inp, minWidth: 100, fontWeight: 600 }}>
            {Array.from({ length: 2040 - 2022 + 1 }, (_, k) => 2022 + k).map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          {['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'].map((nome, k) => {
            const m = String(k + 1);
            const ativo = mes === m;
            return (
              <button key={k} onClick={() => setMes(ativo ? '' : m)} style={{
                flex: 1, padding: '4px 0', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer',
                border: '1px solid ' + (ativo ? '#0a1628' : '#c8d0da'),
                background: ativo ? '#0a1628' : '#fff', color: ativo ? '#fff' : '#374151',
              }}>{nome}</button>
            );
          })}
        </div>
        {mes && <div style={{ textAlign: 'center' }}><button onClick={() => setMes('')} style={{ ...inp, cursor: 'pointer', color: '#6b7280' }}>ver o ano todo</button></div>}
      </div>

      {/* Filtros consultor + serviço (consultor só para o admin — os demais já
          recebem do servidor apenas as próprias vendas) */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        {ehVagner() ? (
          <select value={consultor} onChange={e => setConsultor(e.target.value)} style={{ ...inp, minWidth: 180 }}>
            <option value="">Consultor: todos</option>
            {consultores.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        ) : (
          <span style={{ fontSize: 12, fontWeight: 600, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '4px 10px' }}>
            Mostrando apenas as suas vendas
          </span>
        )}
        <input value={servico} onChange={e => setServico(e.target.value)} placeholder="Buscar serviço vendido..." style={{ ...inp, flex: 1, minWidth: 200 }} />
      </div>

      {/* Métricas — vendas = pedidos (linhas de item do mesmo pedido não inflam) */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
        {[
          { label: 'Total vendido', valor: moedaBR(totalValor), cor: '#15803d' },
          { label: 'Nº de vendas', valor: nPriv(nPedidos), cor: '#0a1628' },
          { label: 'Ticket médio', valor: nPedidos ? moedaBR(totalValor / nPedidos) : '—', cor: '#1d4ed8' },
          {
            label: comparativo?.rotulo || 'Comparativo',
            valor: comparativo ? `${comparativo.delta >= 0 ? '↑' : '↓'} ${Math.abs(Math.round(comparativo.delta * 100))}%` : '—',
            cor: comparativo ? (comparativo.delta >= 0 ? '#15803d' : '#dc2626') : '#9ca3af',
          },
        ].map((m, i) => (
          <div key={i} style={{ background: '#f9fafb', borderRadius: 10, padding: '10px 14px', flex: 1, minWidth: 130 }}>
            <div style={{ fontSize: 11, color: '#6b7280' }}>{m.label}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: m.cor, marginTop: 2 }}>{m.valor}</div>
          </div>
        ))}
      </div>

      {/* Gráficos: evolução do ano + mix de pagamento */}
      {!loading && doAno.length > 0 && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
          <GrafMeses titulo={`Faturamento mês a mês (${ano})`} valores={porMesValor} mesSel={mes} onMes={setMes} formato={v => `R$ ${abreviaValor(v)}`}
            flexo={2.4} minWidth={560}
            fantasma={porMesGeral} notaFantasma="Mês sem vendas no sistema: valor do Faturamento Geral, só pra comparação — não entra nos totais nem nas demais telas." />
          {porForma.length > 0 && <GrafDonut titulo="Mix de pagamento (R$)" dados={porForma} formato={moedaBR} />}
        </div>
      )}
      {!loading && filtradas.length > 0 && totalValor > 0 && (
        <div style={{ fontSize: 12, color: '#6b7280', margin: '-4px 0 12px' }}>
          💳 {Math.round(valorParcelado / totalValor * 100)}% do valor vendido foi parcelado ({pedidosParcelados} pedido{pedidosParcelados !== 1 ? 's' : ''})
        </div>
      )}

      {/* Tabela */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
      ) : filtradas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 30, background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', color: '#6b7280', fontSize: 13 }}>
          Nenhuma venda no período/filtro. As vendas entram aqui quando você usa o botão “💾 Gravar Cliente” no CRM.
        </div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
            <thead>
              {/* coluna Hora é só do Vagner (pedido: horário de lançamento reservado) */}
              {/* Categoria oculta a pedido do Vagner (23/07) — o dado segue gravado e alimentando a aba Serviços */}
              <tr>{(ehVagner() ? ['Data', 'Hora', 'Cliente', 'Consultor', 'Serviço', 'Qtd', 'Forma', 'Valor'] : ['Data', 'Cliente', 'Consultor', 'Serviço', 'Qtd', 'Forma', 'Valor']).map((h, i, arr) => <th key={i} style={{ ...th, textAlign: i === arr.length - 1 ? 'right' : h === 'Qtd' ? 'center' : 'left' }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {filtradas.map((v, i) => (
                <tr key={v.id} style={{ background: i % 2 ? '#fafafa' : '#fff' }}>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{fmtBR(v.data_venda)}</td>
                  {ehVagner() && (
                    <td style={{ ...td, whiteSpace: 'nowrap', color: '#6b7280', fontVariantNumeric: 'tabular-nums' }}>
                      {/* horário do lançamento no fuso de Brasília (criado_em vem em UTC) */}
                      {v.criado_em ? new Date(new Date(v.criado_em).getTime() - 3 * 3600 * 1000).toISOString().slice(11, 16) : '—'}
                    </td>
                  )}
                  <td style={td}>{v.cliente_id
                    ? <Link to={`/clientes/${v.cliente_id}/editar`} style={{ color: '#1d4ed8' }}>{v.cliente}</Link>
                    : v.cliente}</td>
                  <td style={td}>{v.consultor || '—'}</td>
                  <td style={td}>{v.servico || '—'}</td>
                  <td style={{ ...td, textAlign: 'center', fontWeight: (v.quantidade || 1) > 1 ? 700 : 400, color: (v.quantidade || 1) > 1 ? '#0a1628' : '#9ca3af' }}>{nPriv(v.quantidade || 1)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{v.forma_pagamento || '—'}{v.num_parcelas > 1 ? ` (${v.num_parcelas}x)` : ''}</td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 600, color: '#15803d', whiteSpace: 'nowrap' }}>{moedaBR(v.valor)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={ehVagner() ? 7 : 6} style={{ ...td, fontWeight: 700, color: '#0a1628', borderTop: '2px solid #0a1628' }}>TOTAL ({filtradas.length} venda{filtradas.length !== 1 ? 's' : ''} · {filtradas.reduce((s, v) => s + (parseInt(v.quantidade) || 1), 0)} itens)</td>
                <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: '#15803d', borderTop: '2px solid #0a1628', whiteSpace: 'nowrap' }}>{moedaBR(totalValor)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}

/* ── Aba: 📑 DRE Gerencial (só Vagner) ──
   Alimentada pelas categorias reais do Financeiro. Regime de CAIXA por
   padrão (o que foi pago/recebido de fato); chavinha pra competência. */
function RelatorioDre() {
  const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  const [dados, setDados] = useState(null);
  const [ano, setAno] = useState(new Date().getFullYear());
  const [regime, setRegime] = useState('caixa');
  const [erro, setErro] = useState('');

  useEffect(() => {
    apiFetch(`/financeiro/dre?ano=${ano}&regime=${regime}`).then(setDados).catch(e => setErro(e.message));
  }, [ano, regime]);

  if (erro) return <div style={{ color: '#dc2626', fontSize: 13 }}>⚠ {erro}</div>;
  if (!dados) return <div style={{ color: '#9ca3af', fontSize: 13 }}>Carregando…</div>;

  const L = dados.linhas;
  const soma = (arr) => arr.reduce((a, b) => a + b, 0);
  const sub = (a, b) => a.map((v, i) => v - b[i]);
  const add = (...arrs) => arrs[0].map((_, i) => arrs.reduce((t, a) => t + a[i], 0));

  const receitaLiq = sub(L.receita, L.impostos);
  const lucroBruto = sub(receitaLiq, L.custos_diretos);
  const totalOper = add(L.folha, L.custos_oper, L.fornecedores, L.marketing, L.outras, L.sem_categoria);
  const resultOper = sub(lucroBruto, totalOper);
  const resultLiq = sub(sub(sub(resultOper, L.financeiras), L.investimentos), L.retiradas);

  const fmt = (v) => v === 0 ? '—' : v.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  const pct = (v, base) => base > 0 ? `${Math.round((v / base) * 100)}%` : '—';

  const LINHAS = [
    ['RECEITA BRUTA', L.receita, 'receita'],
    ['(−) Impostos e Tributos', L.impostos, 'ded'],
    ['= RECEITA LÍQUIDA', receitaLiq, 'total'],
    ['(−) Custos diretos (taxas INPI/GRU)', L.custos_diretos, 'ded'],
    ['= LUCRO BRUTO', lucroBruto, 'total'],
    ['(−) Folha de Pagamento', L.folha, 'ded'],
    ['(−) Custos Operacionais', L.custos_oper, 'ded'],
    ['(−) Fornecedores', L.fornecedores, 'ded'],
    ['(−) Marketing e Vendas', L.marketing, 'ded'],
    ['(−) Outras despesas', L.outras, 'ded'],
    ['(−) Sem categoria ⚠', L.sem_categoria, 'ded'],
    ['= RESULTADO OPERACIONAL', resultOper, 'total'],
    ['(−) Despesas Financeiras', L.financeiras, 'ded'],
    ['(−) Investimentos e Imobilizado', L.investimentos, 'ded'],
    ['(−) Retiradas (Vagner)', L.retiradas, 'ded'],
    ['= RESULTADO LÍQUIDO DE CAIXA', resultLiq, 'final'],
  ];

  const recAno = soma(L.receita);
  const despTotalMes = add(L.impostos, L.custos_diretos, totalOper, L.financeiras, L.investimentos, L.retiradas);
  const maxBarra = Math.max(...L.receita, ...despTotalMes, 1);

  return (
    <div>
      {/* Controles */}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
        <select value={ano} onChange={e => setAno(parseInt(e.target.value, 10))} style={inp}>
          {(dados.anos.length ? dados.anos : [ano]).map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <div style={{ display: 'flex', border: '1px solid #b0b8c4', borderRadius: 4, overflow: 'hidden' }}>
          {[['caixa', '💵 Caixa (pago/recebido)'], ['competencia', '📅 Competência (lançado)']].map(([k, lbl]) => (
            <button key={k} onClick={() => setRegime(k)} style={{
              padding: '4px 12px', fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer',
              background: regime === k ? '#0a1628' : '#fff', color: regime === k ? '#fff' : '#374151',
            }}>{lbl}</button>
          ))}
        </div>
        {dados.alerta_sem_categoria > 0 && (
          <span style={{ fontSize: 11.5, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 4, padding: '3px 8px' }}>
            ⚠ {dados.alerta_sem_categoria} lançamento(s) sem categoria — classifique no Financeiro pra DRE ficar exata
          </span>
        )}
      </div>

      {/* Gráfico receita × despesas por mês */}
      <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: '10px 14px 4px', marginBottom: 10 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', marginBottom: 6 }}>
          <span style={{ color: '#16a34a' }}>▮ RECEITA</span> × <span style={{ color: '#dc2626' }}>▮ DESPESAS</span> por mês (mês verde = fechou positivo)
        </div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'flex-end', height: 90 }}>
          {MESES.map((m, i) => (
            <div key={m} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <div style={{ display: 'flex', gap: 2, alignItems: 'flex-end', height: 70, width: '100%', justifyContent: 'center' }}>
                <div title={`Receita: R$ ${fmt(L.receita[i])}`} style={{ width: '30%', height: `${(L.receita[i] / maxBarra) * 100}%`, background: '#16a34a', borderRadius: '2px 2px 0 0', minHeight: L.receita[i] > 0 ? 3 : 0 }} />
                <div title={`Despesas: R$ ${fmt(despTotalMes[i])}`} style={{ width: '30%', height: `${(despTotalMes[i] / maxBarra) * 100}%`, background: '#dc2626', borderRadius: '2px 2px 0 0', minHeight: despTotalMes[i] > 0 ? 3 : 0 }} />
              </div>
              <span style={{ fontSize: 10, color: resultLiq[i] > 0 ? '#16a34a' : resultLiq[i] < 0 ? '#dc2626' : '#9ca3af', fontWeight: 700 }}>{m}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Tabela DRE */}
      <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto', background: '#fff' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 980 }}>
          <thead>
            <tr>
              <th style={th}>DRE {dados.ano} — {regime === 'caixa' ? 'regime de caixa' : 'regime de competência'}</th>
              {MESES.map(m => <th key={m} style={{ ...th, textAlign: 'right' }}>{m}</th>)}
              <th style={{ ...th, textAlign: 'right', background: '#1e3a5f' }}>Ano</th>
              <th style={{ ...th, textAlign: 'right', background: '#1e3a5f' }}>% Rec.</th>
            </tr>
          </thead>
          <tbody>
            {LINHAS.map(([rotulo, arr, tipo]) => {
              const total = soma(arr);
              const estilos = {
                receita: { fontWeight: 700, color: '#15803d', background: '#f0fdf4' },
                ded: { color: '#374151' },
                total: { fontWeight: 700, color: '#0a1628', background: '#f0f4f8' },
                final: { fontWeight: 800, color: total >= 0 ? '#15803d' : '#dc2626', background: '#e8edf2' },
              }[tipo];
              return (
                <tr key={rotulo}>
                  <td style={{ ...td, ...estilos, whiteSpace: 'nowrap' }}>{rotulo}</td>
                  {arr.map((v, i) => (
                    <td key={i} style={{ ...td, ...estilos, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmt(v)}</td>
                  ))}
                  <td style={{ ...td, ...estilos, textAlign: 'right', fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>{fmt(total)}</td>
                  <td style={{ ...td, ...estilos, textAlign: 'right', color: '#6b7280' }}>{pct(Math.abs(total), recAno)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Memorando: o que vem pela frente (fora da DRE) */}
      <div style={{ display: 'flex', gap: 14, marginTop: 8, fontSize: 12.5, color: '#374151', flexWrap: 'wrap' }}>
        <span>📥 A receber em aberto: <strong style={{ color: '#15803d' }}>R$ {fmt(dados.em_aberto.a_receber)}</strong></span>
        <span>📤 A pagar em aberto: <strong style={{ color: '#dc2626' }}>R$ {fmt(dados.em_aberto.a_pagar)}</strong></span>
        <span style={{ color: '#9ca3af' }}>· fora da DRE (ainda não realizado) · custos diretos = lançamentos com "INPI"/"GRU" na subcategoria ou descrição</span>
      </div>
    </div>
  );
}

/* ── Aba: Faturamento Geral (comparativo ano a ano) ── */
/* ── 📊 Dashboards do Faturamento Geral (modal) ──────────────────────────────
   7 visões sobre a MESMA tabela mês × ano: linhas ano a ano, acumulado YTD,
   projeção de fim de ano, crescimento YoY, heatmap, faturado × a receber e
   cards de recordes. Tudo client-side, sem lib de gráfico. */
const COR_ANO = { 2022: '#b45309', 2023: '#0f766e', 2024: '#7c3aed', 2025: '#1d4ed8', 2026: '#0a1628', 2027: '#dc2626', 2028: '#16a34a' };
const MESES_CURTOS = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

function DashboardsFaturamento({ anos, onFechar }) {
  const kR$ = (n) => `R$ ${abreviaValor(Math.round(n || 0))}`;
  const moeda = (n) => PRIVADO ? 'R$ •••' : `R$ ${(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
  const cor = (ano) => COR_ANO[ano] || '#6b7280';
  const fatura = (a, m) => a?.meses?.find(x => x.mes === m)?.fatura || 0;
  const receber = (a, m) => a?.meses?.find(x => x.mes === m)?.receber || 0;

  const ordenados = [...anos].sort((a, b) => a.ano - b.ano); // 2022 → 2026
  const anoAtualNum = new Date().getFullYear();
  const anoAtual = ordenados.find(a => a.ano === anoAtualNum) || ordenados[ordenados.length - 1];
  const anoAnterior = ordenados.find(a => a.ano === (anoAtual?.ano || 0) - 1);
  // Último mês com faturamento no ano corrente (corta o futuro dos gráficos)
  const ultimoMes = anoAtual ? Math.max(0, ...anoAtual.meses.filter(m => m.fatura > 0).map(m => m.mes)) : 0;

  // ── 7) Recordes ──
  const todosPontos = ordenados.flatMap(a => a.meses.filter(m => m.fatura > 0).map(m => ({ ano: a.ano, mes: m.mes, v: m.fatura })));
  const recorde = todosPontos.reduce((r, p) => p.v > (r?.v || 0) ? p : r, null);
  const cron = [...todosPontos].sort((a, b) => (a.ano - b.ano) || (a.mes - b.mes));
  const mm12 = cron.slice(-12).reduce((s, p) => s + p.v, 0) / Math.max(1, Math.min(12, cron.length));
  const mediaHistorica = todosPontos.reduce((s, p) => s + p.v, 0) / Math.max(1, todosPontos.length);
  const melhorAno = ordenados.reduce((r, a) => a.total_fatura > (r?.total_fatura || 0) ? a : r, null);
  const acimaMedia = anoAtual ? anoAtual.meses.filter(m => m.fatura > mediaHistorica).length : 0;

  // ── 2) Acumulado YTD ──
  const acum = (a) => { let s = 0; return a.meses.map(m => { s += m.fatura; return s; }); };
  const ytdAtual = anoAtual && ultimoMes ? acum(anoAtual)[ultimoMes - 1] : 0;
  const ytdAnterior = anoAnterior && ultimoMes ? acum(anoAnterior)[ultimoMes - 1] : 0;

  // ── 3) Projeções ──
  const mediaAtual = ultimoMes ? ytdAtual / ultimoMes : 0;
  const projRitmo = mediaAtual * 12;
  let projSazonal = null;
  if (anoAnterior && ytdAnterior > 0 && ultimoMes < 12) {
    const razao = ytdAtual / ytdAnterior;
    const restoAnterior = anoAnterior.meses.filter(m => m.mes > ultimoMes).reduce((s, m) => s + m.fatura, 0);
    projSazonal = ytdAtual + restoAnterior * razao;
  }

  // ── 4) Crescimento YoY ──
  const yoy = ordenados.slice(1).map(a => {
    const ant = ordenados.find(x => x.ano === a.ano - 1);
    const cheio = ant && ant.total_fatura > 0 && (a.ano < anoAtualNum);
    if (a.ano === anoAtualNum && ant) {
      const antYtd = ultimoMes ? acum(ant)[ultimoMes - 1] : 0;
      return { ano: a.ano, pct: antYtd > 0 ? (ytdAtual - antYtd) / antYtd : null, rotulo: `até ${MESES_CURTOS[ultimoMes - 1] || ''}` };
    }
    return { ano: a.ano, pct: cheio ? (a.total_fatura - ant.total_fatura) / ant.total_fatura : null, rotulo: 'ano cheio' };
  }).filter(x => x.pct !== null);

  // ── SVG de linhas (usado no 1 e no 2) ──
  const W = 720, H = 220, PAD = 34;
  const linhaSvg = (series, maxV) => {
    const x = (m) => PAD + ((m - 1) / 11) * (W - PAD - 10);
    const y = (v) => H - 26 - (v / maxV) * (H - 44);
    return (
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
        {[0.25, 0.5, 0.75, 1].map(f => (
          <g key={f}>
            <line x1={PAD} x2={W - 10} y1={y(maxV * f)} y2={y(maxV * f)} stroke="#eef2f7" strokeWidth="1" />
            <text x={PAD - 4} y={y(maxV * f) + 3} textAnchor="end" fontSize="8.5" fill="#9ca3af">{abreviaValor(Math.round(maxV * f))}</text>
          </g>
        ))}
        {MESES_CURTOS.map((r, k) => <text key={r} x={x(k + 1)} y={H - 10} textAnchor="middle" fontSize="8.5" fill="#6b7280">{r}</text>)}
        {series.map(s => {
          const pts = s.pontos.filter(p => p.v > 0);
          if (!pts.length) return null;
          return (
            <g key={s.ano}>
              <polyline fill="none" stroke={cor(s.ano)} strokeWidth={s.ano === anoAtualNum ? 3 : 1.8}
                opacity={s.ano === anoAtualNum ? 1 : 0.75}
                points={pts.map(p => `${x(p.m)},${y(p.v)}`).join(' ')} />
              {pts.map(p => <circle key={p.m} cx={x(p.m)} cy={y(p.v)} r={s.ano === anoAtualNum ? 3 : 2} fill={cor(s.ano)} />)}
            </g>
          );
        })}
      </svg>
    );
  };
  const legenda = (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 4 }}>
      {ordenados.map(a => (
        <span key={a.ano} style={{ fontSize: 11.5, fontWeight: a.ano === anoAtualNum ? 800 : 600, color: cor(a.ano) }}>― {a.ano}</span>
      ))}
    </div>
  );
  const serieMensal = ordenados.map(a => ({ ano: a.ano, pontos: a.meses.map(m => ({ m: m.mes, v: m.fatura })) }));
  const maxMensal = Math.max(1, ...serieMensal.flatMap(s => s.pontos.map(p => p.v)));
  const serieAcum = ordenados.map(a => {
    const ac = acum(a);
    // corta o acumulado no último mês com dado (senão vira linha reta no futuro)
    const corte = Math.max(0, ...a.meses.filter(m => m.fatura > 0).map(m => m.mes));
    return { ano: a.ano, pontos: ac.map((v, k) => ({ m: k + 1, v: k + 1 <= corte ? v : 0 })) };
  });
  const maxAcum = Math.max(1, ...serieAcum.flatMap(s => s.pontos.map(p => p.v)));

  // ── 5) Heatmap ──
  // Escala POR ANO em 5 faixas de cor (semáforo): a posição do mês em relação
  // ao melhor mês DAQUELE ano — vermelho fraco → verde forte (pedido 20/08)
  const FAIXAS_CALOR = [
    { min: 0.8, bg: '#16a34a', fg: '#fff', rotulo: '80–100% (melhor)' },
    { min: 0.6, bg: '#86efac', fg: '#14532d', rotulo: '60–80%' },
    { min: 0.4, bg: '#fde047', fg: '#713f12', rotulo: '40–60%' },
    { min: 0.2, bg: '#fdba74', fg: '#7c2d12', rotulo: '20–40%' },
    { min: 0, bg: '#fca5a5', fg: '#7f1d1d', rotulo: 'até 20% (fraco)' },
  ];
  const corCel = (v, maxAno) => {
    if (v <= 0) return { bg: '#f8fafc', fg: '#374151' };
    const p = v / Math.max(1, maxAno);
    return FAIXAS_CALOR.find(f => p >= f.min) || FAIXAS_CALOR[FAIXAS_CALOR.length - 1];
  };

  // ── 6) Faturado × A receber ──
  const [anoPar, setAnoPar] = useState(anoAtualNum);
  const aPar = ordenados.find(a => a.ano === anoPar) || anoAtual;
  const maxPar = Math.max(1, ...(aPar?.meses || []).flatMap(m => [m.fatura, m.receber]));

  const secao = { background: '#fff', border: '1px solid #dbe2ea', borderRadius: 10, padding: '12px 16px' };
  const tituloSec = { fontSize: 13, fontWeight: 800, color: '#0a1628', marginBottom: 8 };

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1400, padding: 12 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#f1f5f9', borderRadius: 10, width: '96vw', maxWidth: 1200, height: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ color: '#fff', fontSize: 14, fontWeight: 800 }}>📊 Dashboards do Faturamento Geral</span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 14, display: 'flex', flexDirection: 'column', gap: 12 }}>

          {/* 7. Recordes */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 8 }}>
            {[
              { r: '🏆 Melhor mês da história', v: recorde ? kR$(recorde.v) : '—', d: recorde ? `${MESES_CURTOS[recorde.mes - 1]}/${String(recorde.ano).slice(2)}` : '' },
              { r: '📈 Média móvel (12 meses)', v: kR$(mm12), d: 'faturamento/mês' },
              { r: '⭐ Melhor ano', v: melhorAno ? kR$(melhorAno.total_fatura) : '—', d: melhorAno ? String(melhorAno.ano) : '' },
              { r: `🔥 ${anoAtualNum} acima da média`, v: `${acimaMedia} mês(es)`, d: `média histórica ${kR$(mediaHistorica)}/mês` },
            ].map(c => (
              <div key={c.r} style={{ ...secao, padding: '10px 14px' }}>
                <div style={{ fontSize: 10.5, color: '#6b7280', fontWeight: 700 }}>{c.r}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#0a1628' }}>{c.v}</div>
                <div style={{ fontSize: 10.5, color: '#9ca3af' }}>{c.d}</div>
              </div>
            ))}
          </div>

          {/* 1. Linhas ano a ano */}
          <div style={secao}>
            <div style={tituloSec}>📈 Evolução ano a ano — faturamento por mês</div>
            {linhaSvg(serieMensal, maxMensal)}
            {legenda}
          </div>

          {/* 2. Acumulado YTD */}
          <div style={secao}>
            <div style={tituloSec}>🏁 Corrida do acumulado no ano</div>
            {ultimoMes > 0 && ytdAnterior > 0 && (
              <div style={{ fontSize: 12.5, color: '#374151', marginBottom: 6 }}>
                Até {MESES_CURTOS[ultimoMes - 1]}: <b>{anoAtual.ano}</b> {kR$(ytdAtual)} × <b>{anoAnterior.ano}</b> {kR$(ytdAnterior)} —{' '}
                <b style={{ color: ytdAtual >= ytdAnterior ? '#15803d' : '#dc2626' }}>
                  {ytdAtual >= ytdAnterior ? '↑' : '↓'} {Math.abs(Math.round((ytdAtual - ytdAnterior) / ytdAnterior * 100))}%
                </b>
              </div>
            )}
            {linhaSvg(serieAcum, maxAcum)}
            {legenda}
          </div>

          {/* 3. Projeção de fim de ano */}
          <div style={secao}>
            <div style={tituloSec}>🔮 Projeção de {anoAtualNum}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
              <div style={{ background: '#f8fafc', borderRadius: 8, padding: '10px 14px' }}>
                <div style={{ fontSize: 10.5, color: '#6b7280', fontWeight: 700 }}>Realizado até {MESES_CURTOS[ultimoMes - 1] || '—'}</div>
                <div style={{ fontSize: 19, fontWeight: 800, color: '#0a1628' }}>{kR$(ytdAtual)}</div>
                <div style={{ fontSize: 10.5, color: '#9ca3af' }}>média {kR$(mediaAtual)}/mês</div>
              </div>
              <div style={{ background: '#eff6ff', borderRadius: 8, padding: '10px 14px' }}>
                <div style={{ fontSize: 10.5, color: '#1d4ed8', fontWeight: 700 }}>No ritmo atual (média × 12)</div>
                <div style={{ fontSize: 19, fontWeight: 800, color: '#1d4ed8' }}>{kR$(projRitmo)}</div>
                <div style={{ fontSize: 10.5, color: '#9ca3af' }}>se set–dez repetirem a média</div>
              </div>
              {projSazonal !== null && (
                <div style={{ background: '#f0fdf4', borderRadius: 8, padding: '10px 14px' }}>
                  <div style={{ fontSize: 10.5, color: '#15803d', fontWeight: 700 }}>Com a sazonalidade de {anoAnterior.ano}</div>
                  <div style={{ fontSize: 19, fontWeight: 800, color: '#15803d' }}>{kR$(projSazonal)}</div>
                  <div style={{ fontSize: 10.5, color: '#9ca3af' }}>set–dez de {anoAnterior.ano} no seu ritmo de {anoAtualNum}</div>
                </div>
              )}
            </div>
            <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 6 }}>Projeção é estimativa, não meta batida — os dois métodos dão o intervalo provável.</div>
          </div>

          {/* 4. Crescimento YoY */}
          <div style={secao}>
            <div style={tituloSec}>📊 Crescimento ano contra ano</div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
              {yoy.map(x => {
                const h = Math.min(110, Math.max(8, Math.abs(x.pct) * 60));
                return (
                  <div key={x.ano} style={{ flex: 1, minWidth: 90, textAlign: 'center' }}>
                    <div style={{ fontSize: 14, fontWeight: 800, color: x.pct >= 0 ? '#15803d' : '#dc2626' }}>{x.pct >= 0 ? '+' : ''}{Math.round(x.pct * 100)}%</div>
                    <div style={{ width: '60%', margin: '0 auto', height: h, background: x.pct >= 0 ? '#bbf7d0' : '#fecaca', border: `2px solid ${x.pct >= 0 ? '#16a34a' : '#dc2626'}`, borderRadius: '4px 4px 0 0' }} />
                    <div style={{ fontSize: 11.5, fontWeight: 700, color: '#0a1628', marginTop: 3 }}>{x.ano} vs {x.ano - 1}</div>
                    <div style={{ fontSize: 9.5, color: '#9ca3af' }}>{x.rotulo}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* 5. Heatmap */}
          <div style={secao}>
            <div style={tituloSec}>🌡️ Mapa de calor — meses fortes e fracos DENTRO de cada ano</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
              {[...FAIXAS_CALOR].reverse().map(f => (
                <span key={f.rotulo} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 10.5, color: '#374151' }}>
                  <span style={{ width: 14, height: 14, background: f.bg, borderRadius: 3, border: '1px solid rgba(0,0,0,0.08)' }} />
                  {f.rotulo}
                </span>
              ))}
              <span style={{ fontSize: 10.5, color: '#9ca3af' }}>· % em relação ao melhor mês do próprio ano</span>
            </div>
            <div style={{ overflowX: 'auto' }}>
              {(() => {
                // Moldura de trimestre: borda nas laterais do 1º/3º mês de cada
                // tri, topo na faixa "Nº TRI" e fundo na última linha de ano
                const TRI_BORDA = '2px solid #94a3b8';
                const linhas = [...ordenados].reverse();
                return (
                  <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 640 }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '2px 6px' }}></th>
                        {MESES_CURTOS.map(m => <th key={m} style={{ fontSize: 10, color: '#6b7280', padding: '2px 4px' }}>{m}</th>)}
                      </tr>
                      <tr>
                        <th></th>
                        {[1, 2, 3, 4].map(t => (
                          <th key={t} colSpan={3}
                            style={{ fontSize: 9.5, fontWeight: 800, color: '#475569', letterSpacing: 1, background: '#f1f5f9', padding: '3px 0', borderTop: TRI_BORDA, borderLeft: TRI_BORDA, borderRight: TRI_BORDA }}>
                            {t}º TRI
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {linhas.map((a, r) => {
                        const maxAno = Math.max(1, ...a.meses.map(m => m.fatura || 0));
                        const ultimaLinha = r === linhas.length - 1;
                        return (
                          <tr key={a.ano}>
                            <td style={{ fontSize: 11.5, fontWeight: 800, color: cor(a.ano), padding: '2px 6px', whiteSpace: 'nowrap' }}>{a.ano}</td>
                            {Array.from({ length: 12 }, (_, k) => {
                              const v = fatura(a, k + 1);
                              const c = corCel(v, maxAno);
                              return (
                                <td key={k} title={`${MESES_CURTOS[k]}/${a.ano} (${Math.floor(k / 3) + 1}º tri): ${v ? moeda(v) : '—'} (${v > 0 ? Math.round(v / maxAno * 100) + '% do melhor mês de ' + a.ano : 'sem dado'})`}
                                  style={{
                                    background: c.bg, textAlign: 'center', fontSize: 9.5, fontWeight: 700,
                                    color: c.fg, padding: '7px 2px',
                                    borderTop: '2px solid #fff',
                                    borderLeft: k % 3 === 0 ? TRI_BORDA : '2px solid #fff',
                                    borderRight: k % 3 === 2 ? TRI_BORDA : '2px solid #fff',
                                    borderBottom: ultimaLinha ? TRI_BORDA : '2px solid #fff',
                                  }}>
                                  {v > 0 ? abreviaValor(Math.round(v)) : ''}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                );
              })()}
            </div>
          </div>

          {/* 6. Faturado × A receber */}
          <div style={secao}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
              <div style={{ ...tituloSec, marginBottom: 0 }}>⚖️ Faturado × A receber</div>
              {ordenados.map(a => (
                <button key={a.ano} onClick={() => setAnoPar(a.ano)}
                  style={{ padding: '2px 10px', borderRadius: 12, fontSize: 11.5, fontWeight: 700, cursor: 'pointer', border: '1px solid', borderColor: anoPar === a.ano ? '#0a1628' : '#d1d5db', background: anoPar === a.ano ? '#0a1628' : '#fff', color: anoPar === a.ano ? '#fff' : '#374151' }}>{a.ano}</button>
              ))}
              <span style={{ fontSize: 11, color: '#6b7280' }}>▮ faturado (azul) · ▮ a receber (verde)</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 130 }}>
              {Array.from({ length: 12 }, (_, k) => {
                const f = fatura(aPar, k + 1), r = receber(aPar, k + 1);
                return (
                  <div key={k} title={`${MESES_CURTOS[k]}: faturado ${moeda(f)} · a receber ${moeda(r)}`}
                    style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                    <div style={{ display: 'flex', gap: 2, alignItems: 'flex-end', width: '100%', justifyContent: 'center', flex: 1 }}>
                      <div style={{ width: '38%', height: `${Math.max(f > 0 ? 4 : 1, f / maxPar * 100)}%`, background: '#1d4ed8', borderRadius: '2px 2px 0 0' }} />
                      <div style={{ width: '38%', height: `${Math.max(r > 0 ? 4 : 1, r / maxPar * 100)}%`, background: '#16a34a', borderRadius: '2px 2px 0 0' }} />
                    </div>
                    <div style={{ fontSize: 9, color: '#6b7280', marginTop: 3 }}>{MESES_CURTOS[k]}</div>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

function RelatorioFaturamento() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [modalDash, setModalDash] = useState(false);

  useEffect(() => {
    apiFetch('/financeiro/faturamento-geral')
      .then(setDados)
      .catch(e => setErro(e.message));
  }, []);

  const MESES = ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'];
  const moedaBR = (n) => n ? (PRIVADO ? 'R$ •••' : `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`) : '—';
  const cel = { padding: '4px 10px', fontSize: 12, textAlign: 'right', whiteSpace: 'nowrap', borderBottom: '1px solid #e8eaed', color: '#374151' };

  if (erro) return <div style={{ color: '#dc2626', fontSize: 13 }}>{erro}</div>;
  if (!dados) return <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Carregando...</div>;

  const anos = dados.anos || [];
  const geralFatura = anos.reduce((s, a) => s + (a.total_fatura || 0), 0);
  const geralReceber = anos.reduce((s, a) => s + (a.total_receber || 0), 0);
  const faixaAnos = anos.length ? `${Math.min(...anos.map(a => a.ano))}–${Math.max(...anos.map(a => a.ano))}` : '';
  return (
    <div>
      <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 10px' }}>
        <strong>FATURA.</strong> = vendas do mês (Relatório de Vendas) · <strong>A RECEBER</strong> = vencimentos do Contas a Receber.
        Meses anteriores a jul/2026 usam os números históricos da planilha; daqui pra frente o sistema alimenta sozinho.
      </p>

      {/* Somatório geral de todos os anos + porta dos dashboards */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, padding: '8px 14px', flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 11, color: '#6b7280' }}>💰 Faturamento geral — todos os anos ({faixaAnos})</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#0a1628' }}>{moedaBR(geralFatura)}</div>
        </div>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '8px 14px', flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 11, color: '#6b7280' }}>📥 A receber geral — todos os anos ({faixaAnos})</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#15803d' }}>{moedaBR(geralReceber)}</div>
        </div>
        <button onClick={() => setModalDash(true)}
          title="7 visões: evolução ano a ano, acumulado, projeção, crescimento, heatmap, faturado × a receber e recordes"
          style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 800, cursor: 'pointer', alignSelf: 'stretch' }}>
          📊 Dashboards
        </button>
      </div>
      {modalDash && <DashboardsFaturamento anos={anos} onFechar={() => setModalDash(false)} />}
      <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'collapse', background: '#fff', minWidth: 760 }}>
          <thead>
            <tr>
              <th rowSpan={2} style={{ ...th, position: 'sticky', left: 0, zIndex: 2, textAlign: 'center', borderRight: '2px solid #fff' }}>MESES</th>
              {anos.map(a => (
                <th key={a.ano} colSpan={2} style={{ ...th, textAlign: 'center', borderLeft: '2px solid #26364a' }}>{a.ano}</th>
              ))}
            </tr>
            <tr>
              {anos.map(a => (
                <React.Fragment key={a.ano}>
                  <th style={{ ...th, background: '#26364a', textAlign: 'right', borderLeft: '2px solid #26364a' }}>FATURA.</th>
                  <th style={{ ...th, background: '#26364a', textAlign: 'right' }}>A RECEBER</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {MESES.map((nome, i) => (
              <tr key={i} style={{ background: i % 2 ? '#fafafa' : '#fff' }}>
                <td style={{ ...cel, textAlign: 'left', fontWeight: 700, color: '#0a1628', position: 'sticky', left: 0, background: i % 2 ? '#f3f4f6' : '#f9fafb', zIndex: 1 }}>{nome}</td>
                {anos.map(a => {
                  const m = a.meses[i] || {};
                  return (
                    <React.Fragment key={a.ano}>
                      <td style={{ ...cel, borderLeft: '2px solid #c8d0da' }}>{moedaBR(m.fatura)}</td>
                      <td style={{ ...cel, color: '#15803d' }}>{moedaBR(m.receber)}</td>
                    </React.Fragment>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td style={{ ...cel, textAlign: 'left', fontWeight: 800, color: '#0a1628', borderTop: '2px solid #0a1628', position: 'sticky', left: 0, background: '#fef9c3', zIndex: 1 }}>TOTAL</td>
              {anos.map(a => (
                <React.Fragment key={a.ano}>
                  <td style={{ ...cel, fontWeight: 800, color: '#0a1628', borderTop: '2px solid #0a1628', borderLeft: '2px solid #c8d0da', background: '#fef9c3' }}>{moedaBR(a.total_fatura)}</td>
                  <td style={{ ...cel, fontWeight: 800, color: '#15803d', borderTop: '2px solid #0a1628', background: '#fef9c3' }}>{moedaBR(a.total_receber)}</td>
                </React.Fragment>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── Aba: SDR Analitics (só Vagner) ──
   Painel de eficiência da página SDR + análise de ritmo exclusiva: em que
   horas do dia o trabalho acontece, mapa de calor dia × hora e pausas —
   pra enxergar quando a produtividade cai (ex.: quando o Vagner sai). */
const DIAS_SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const diaSemana = (iso) => DIAS_SEMANA[new Date(iso + 'T12:00:00Z').getUTCDay()];
const fmtDia = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

const PERIODOS_SDR = [
  ['hoje', 'Hoje'], ['ontem', 'Ontem'], ['7', '7 dias'], ['30', '30 dias'], ['90', '90 dias'],
];
// hoje/ontem viram ?periodo=, números viram ?dias=
const queryPeriodoSdr = (p) => (['hoje', 'ontem'].includes(p) ? `periodo=${p}` : `dias=${p}`);

function SdrAnalitics() {
  const [periodo, setPeriodo] = useState('30');
  const [dados, setDados] = useState(null);
  // Filtro por SDR: '' = todos; nomes vêm do cargo SDR no cadastro
  const [sdrFiltro, setSdrFiltro] = useState('');
  const [sdrsEquipe, setSdrsEquipe] = useState([]);

  useEffect(() => {
    apiFetch('/usuarios').then(us => {
      if (Array.isArray(us)) setSdrsEquipe(us.filter(u => (u.cargo || '').toLowerCase().includes('sdr')).map(u => u.nome).sort());
    }).catch(() => {});
  }, []);

  useEffect(() => {
    setDados(null);
    apiFetch(`/sdr/analitics?${queryPeriodoSdr(periodo)}${sdrFiltro ? `&sdr=${encodeURIComponent(sdrFiltro)}` : ''}`).then(setDados).catch(() => setDados({ erro: true }));
  }, [periodo, sdrFiltro]);

  const cartao = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 8, padding: 12 };
  const horas = (dados?.por_hora || []).slice(6, 21); // 06h às 20h
  const maxHora = Math.max(1, ...horas.map(h => h.total));
  const maxCelula = Math.max(1, ...(dados?.heatmap || []).flatMap(l => l.horas));
  const temDados = dados && !dados.erro && (dados.manha + dados.tarde) > 0;
  const quedaTarde = temDados && dados.manha > 0 ? Math.round((1 - dados.tarde / dados.manha) * 100) : 0;

  return (
    <div style={{ maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <div>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: '#0a1628', margin: 0 }}>🔍 Análise de ritmo <span style={{ fontSize: 11, fontWeight: 600, color: '#b45309', background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 4, padding: '1px 6px', verticalAlign: 'middle' }}>exclusivo</span></h2>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0' }}>Em que horas o trabalho acontece de verdade — quedas de ritmo e pausas longas aparecem aqui.</p>
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {/* Filtro por SDR: Todos / Bianca / Tacila… */}
          <div style={{ display: 'flex', border: '1px solid #d1d5db', borderRadius: 6, overflow: 'hidden' }}>
            {['', ...sdrsEquipe].map(s => (
              <button key={s || 'todos'} onClick={() => setSdrFiltro(s)}
                style={{ padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', border: 'none', background: sdrFiltro === s ? '#0a1628' : '#fff', color: sdrFiltro === s ? '#fff' : '#374151' }}>
                {s === '' ? 'Todos' : `👩‍💼 ${s.split(' ')[0]}`}
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            {PERIODOS_SDR.map(([v, rotulo]) => (
              <button key={v} onClick={() => setPeriodo(v)}
                style={{ padding: '5px 12px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: '1px solid', borderColor: periodo === v ? '#0a1628' : '#c8d0da', background: periodo === v ? '#0a1628' : '#fff', color: periodo === v ? '#fff' : '#374151' }}>
                {rotulo}
              </button>
            ))}
          </div>
        </div>
      </div>

      {!dados ? (
        <div style={{ ...cartao, textAlign: 'center', color: '#6b7280', marginBottom: 14 }}>Calculando…</div>
      ) : dados.erro ? (
        <div style={{ ...cartao, textAlign: 'center', color: '#dc2626', marginBottom: 14 }}>Não consegui carregar a análise. Tente de novo.</div>
      ) : !temDados ? (
        <div style={{ ...cartao, textAlign: 'center', color: '#6b7280', padding: 24, marginBottom: 14 }}>
          Ainda não há atividade registrada no período — os horários passam a contar a cada ação das SDRs na fila (WhatsApp, tentativa, desfecho).
        </div>
      ) : (
        <>
          {/* Manhã × tarde */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
            <div style={{ ...cartao, flex: 1, minWidth: 160, textAlign: 'center', padding: '10px 8px' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#6b7280' }}>Manhã (7h–12h)</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: '#0a1628' }}>{dados.manha}</div>
              <div style={{ fontSize: 11, color: '#9ca3af' }}>ações</div>
            </div>
            <div style={{ ...cartao, flex: 1, minWidth: 160, textAlign: 'center', padding: '10px 8px' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#6b7280' }}>Tarde (13h–19h)</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: dados.tarde < dados.manha ? '#dc2626' : '#15803d' }}>{dados.tarde}</div>
              <div style={{ fontSize: 11, color: '#9ca3af' }}>ações</div>
            </div>
            <div style={{ ...cartao, flex: 2, minWidth: 220, padding: '10px 12px', display: 'flex', alignItems: 'center' }}>
              <div style={{ fontSize: 12.5, color: '#374151', lineHeight: 1.5 }}>
                {dados.tarde < dados.manha
                  ? <>⚠️ A tarde rende <strong style={{ color: '#dc2626' }}>{quedaTarde}% menos</strong> que a manhã. Cruze com o mapa abaixo pra ver <strong>em quais dias e horas</strong> o ritmo caiu.</>
                  : <>✅ O ritmo da tarde está igual ou melhor que o da manhã no período.</>}
              </div>
            </div>
          </div>

          {/* Ritmo por hora */}
          <div style={{ ...cartao, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Ritmo por hora do dia <span style={{ fontWeight: 400, color: '#9ca3af' }}>(ações no período, horário local)</span></div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 80 }}>
              {horas.map(h => (
                <div key={h.hora} title={dados.sdrs.map(s => `${s}: ${h[s] || 0}`).join('\n') || String(h.total)} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  {h.total > 0 && <span style={{ fontSize: 9, color: '#6b7280', fontWeight: 600 }}>{h.total}</span>}
                  <div style={{ width: '100%', borderRadius: '3px 3px 0 0', background: h.total ? (h.hora < 12 ? '#0a1628' : '#b45309') : '#f3f4f6', height: `${Math.max(3, (h.total / maxHora) * 58)}px`, opacity: h.total ? 0.85 : 1 }} />
                  <span style={{ fontSize: 9, color: '#9ca3af' }}>{h.hora}h</span>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>Barras escuras = manhã · barras cor de bronze = tarde/noite. Passe o mouse pra ver por SDR.</div>
          </div>

          {/* Mapa de calor dia × hora */}
          <div style={{ ...cartao, marginBottom: 12, overflowX: 'auto' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Mapa de calor — últimos 14 dias × hora <span style={{ fontWeight: 400, color: '#9ca3af' }}>(quanto mais escuro, mais atividade)</span></div>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={{ fontSize: 10, color: '#6b7280', padding: '2px 6px', textAlign: 'right' }}></th>
                {Array.from({ length: 15 }, (_, i) => i + 6).map(h => <th key={h} style={{ fontSize: 9, color: '#9ca3af', fontWeight: 600, padding: '2px 1px', minWidth: 26, textAlign: 'center' }}>{h}h</th>)}
              </tr></thead>
              <tbody>
                {dados.heatmap.map(l => {
                  const fds = ['sáb', 'dom'].includes(diaSemana(l.dia));
                  return (
                    <tr key={l.dia}>
                      <td style={{ fontSize: 10.5, color: fds ? '#b0b8c4' : '#374151', fontWeight: 600, padding: '2px 8px 2px 0', textAlign: 'right', whiteSpace: 'nowrap' }}>{diaSemana(l.dia)} {fmtDia(l.dia)}</td>
                      {l.horas.slice(6, 21).map((v, i) => (
                        <td key={i} title={`${fmtDia(l.dia)} ${i + 6}h: ${v} açõe(s)`} style={{ padding: 1 }}>
                          <div style={{ width: '100%', height: 18, borderRadius: 3, background: v === 0 ? '#f3f4f6' : `rgba(10, 22, 40, ${Math.min(1, 0.18 + (v / maxCelula) * 0.82)})` }} />
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Detalhe por dia */}
          <div style={{ ...cartao, padding: 0, marginBottom: 4, overflowX: 'auto' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', padding: '10px 12px 4px' }}>Jornada por dia <span style={{ fontWeight: 400, color: '#9ca3af' }}>(primeira e última ação, maior pausa)</span></div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={th}>Dia</th><th style={th}>SDR</th><th style={th}>Contatos</th><th style={th}>Ações</th>
                <th style={th}>Primeira ação</th><th style={th}>Última ação</th><th style={th}>Maior pausa</th>
              </tr></thead>
              <tbody>
                {dados.dias_detalhe.map(d => (
                  <tr key={d.dia + d.sdr}>
                    <td style={{ ...td, fontWeight: 600, whiteSpace: 'nowrap' }}>{diaSemana(d.dia)} {fmtDia(d.dia)}</td>
                    <td style={td}>{d.sdr}</td>
                    <td style={td}>{d.contatos}</td>
                    <td style={td}>{d.acoes}</td>
                    <td style={{ ...td, color: d.primeira > '09:30' ? '#b45309' : '#374151', fontWeight: d.primeira > '09:30' ? 700 : 400 }}>{d.primeira}</td>
                    <td style={{ ...td, color: d.ultima < '16:00' ? '#b45309' : '#374151', fontWeight: d.ultima < '16:00' ? 700 : 400 }}>{d.ultima}</td>
                    <td style={{ ...td, color: d.maior_pausa_min > 90 ? '#dc2626' : '#374151', fontWeight: d.maior_pausa_min > 90 ? 700 : 400 }}>
                      {d.maior_pausa_min >= 60 ? `${Math.floor(d.maior_pausa_min / 60)}h${String(d.maior_pausa_min % 60).padStart(2, '0')}` : `${d.maior_pausa_min} min`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ fontSize: 11, color: '#6b7280', padding: '6px 12px 10px' }}>
              Destaques: <span style={{ color: '#b45309', fontWeight: 700 }}>começou tarde / parou cedo</span> · <span style={{ color: '#dc2626', fontWeight: 700 }}>pausa acima de 1h30</span>.
            </div>
          </div>
        </>
      )}

      {/* Painel padrão (o mesmo da página SDR), obedecendo o filtro de SDR */}
      <div style={{ borderTop: '2px solid #c8d0da', margin: '16px 0 12px' }} />
      <PainelEficiencia sdrFiltro={sdrFiltro} />
    </div>
  );
}

/* ── Aba: Closer Analitics (só Vagner) ──
   Execução da rotina semanal do closer: taxa de execução, pontualidade,
   mapa das semanas (verde = no horário, âmbar = atrasado, vermelho = não
   feito) e os resultados anotados bloco a bloco — presença E qualidade. */
const CORES_EXEC = {
  no_horario: { cor: '#16a34a', rotulo: 'Feito no horário' },
  atrasado:   { cor: '#f59e0b', rotulo: 'Feito fora do horário' },
  nao_feito:  { cor: '#dc2626', rotulo: 'Não realizado' },
  vencido:    { cor: '#b45309', rotulo: 'Venceu sem desfecho' },
  pendente:   { cor: '#d1d5db', rotulo: 'Ainda vai acontecer' },
};
const classeBloco = (b) => {
  if (b.status === 'feito') return b.no_horario ? 'no_horario' : 'atrasado';
  if (b.status === 'nao_feito') return 'nao_feito';
  return b.vencido ? 'vencido' : 'pendente';
};

function CloserAnalitics() {
  const [semanas, setSemanas] = useState('8');
  const [closerFiltro, setCloserFiltro] = useState('');
  const [dados, setDados] = useState(null);

  useEffect(() => {
    setDados(null);
    apiFetch(`/closer/analitics?semanas=${semanas}${closerFiltro ? `&closer=${encodeURIComponent(closerFiltro)}` : ''}`)
      .then(setDados).catch(() => setDados({ erro: true }));
  }, [semanas, closerFiltro]);

  const cartao = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 8, padding: 12 };
  const fmtBRc = (iso) => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : '—';

  // Blocos já chegam anotados do servidor (no_horario / vencido)
  const blocos = dados?.blocos || [];
  const geral = dados?.geral;
  const semanasDoMapa = [...new Set(blocos.map(b => b.semana))].sort().reverse();
  const somarDiasIso = (iso, n) => { const d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

  return (
    <div style={{ maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <div>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: '#0a1628', margin: 0 }}>🧭 Execução da rotina <span style={{ fontSize: 11, fontWeight: 600, color: '#b45309', background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 4, padding: '1px 6px', verticalAlign: 'middle' }}>exclusivo</span></h2>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0' }}>A semana planejada foi executada? No horário certo? O mapa mostra onde o closer se perde.</p>
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', border: '1px solid #d1d5db', borderRadius: 6, overflow: 'hidden' }}>
            {['', ...(dados?.closers || [])].map(c => (
              <button key={c || 'todos'} onClick={() => setCloserFiltro(c)}
                style={{ padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', border: 'none', background: closerFiltro === c ? '#0a1628' : '#fff', color: closerFiltro === c ? '#fff' : '#374151' }}>
                {c === '' ? 'Todos' : `🧑‍💼 ${c.split(' ')[0]}`}
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {[['4', '4 sem.'], ['8', '8 sem.'], ['12', '12 sem.']].map(([v, rotulo]) => (
              <button key={v} onClick={() => setSemanas(v)}
                style={{ padding: '5px 12px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: '1px solid', borderColor: semanas === v ? '#0a1628' : '#c8d0da', background: semanas === v ? '#0a1628' : '#fff', color: semanas === v ? '#fff' : '#374151' }}>
                {rotulo}
              </button>
            ))}
          </div>
        </div>
      </div>

      {!dados ? (
        <div style={{ ...cartao, textAlign: 'center', color: '#6b7280' }}>Calculando…</div>
      ) : dados.erro ? (
        <div style={{ ...cartao, textAlign: 'center', color: '#dc2626' }}>Não consegui carregar. Tente de novo.</div>
      ) : !blocos.length ? (
        <div style={{ ...cartao, textAlign: 'center', color: '#6b7280', padding: 24 }}>
          Nenhuma semana gerada no período ainda — monte a rotina padrão na página 🧭 Closer e gere a semana.
        </div>
      ) : (
        <>
          {/* Cards gerais */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 8, marginBottom: 12 }}>
            {[
              { label: 'Execução', valor: `${geral.taxa}%`, cor: geral.taxa >= 80 ? '#16a34a' : geral.taxa >= 50 ? '#f59e0b' : '#dc2626', sub: `${geral.feitos} de ${geral.feitos + geral.nao_feitos + geral.vencidos} devidos` },
              { label: 'Pontualidade', valor: `${geral.pontualidade}%`, cor: geral.pontualidade >= 80 ? '#16a34a' : '#f59e0b', sub: `${geral.no_horario} no horário` },
              { label: 'Não realizados', valor: geral.nao_feitos, cor: '#dc2626', sub: 'com motivo dado' },
              { label: 'Venceram calados', valor: geral.vencidos, cor: '#b45309', sub: 'sem nenhum desfecho' },
              { label: 'Ainda por vir', valor: geral.pendentes, cor: '#6b7280', sub: 'blocos futuros' },
            ].map(({ label, valor, cor, sub }) => (
              <div key={label} style={{ ...cartao, padding: '10px 12px' }}>
                <div style={{ fontSize: 22, fontWeight: 800, color: cor }}>{valor}</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#0a1628' }}>{label}</div>
                <div style={{ fontSize: 10.5, color: '#9ca3af' }}>{sub}</div>
              </div>
            ))}
          </div>

          {/* Por closer (quando "Todos") */}
          {!closerFiltro && dados.por_closer.length > 1 && (
            <div style={{ ...cartao, padding: 0, marginBottom: 12, overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>
                  <th style={th}>Closer</th><th style={th}>Planejados</th><th style={th}>Feitos</th>
                  <th style={th}>No horário</th><th style={th}>Atrasados</th><th style={th}>Não feitos</th>
                  <th style={th}>Venceram</th><th style={th}>Execução</th>
                </tr></thead>
                <tbody>
                  {dados.por_closer.map(c => (
                    <tr key={c.closer}>
                      <td style={{ ...td, fontWeight: 700, color: '#0a1628' }}>{c.closer}</td>
                      <td style={td}>{c.planejados}</td>
                      <td style={{ ...td, color: '#16a34a', fontWeight: 700 }}>{c.feitos}</td>
                      <td style={td}>{c.no_horario}</td>
                      <td style={{ ...td, color: c.atrasados ? '#b45309' : '#374151' }}>{c.atrasados}</td>
                      <td style={{ ...td, color: c.nao_feitos ? '#dc2626' : '#374151' }}>{c.nao_feitos}</td>
                      <td style={{ ...td, color: c.vencidos ? '#b45309' : '#374151' }}>{c.vencidos}</td>
                      <td style={{ ...td, fontWeight: 800, color: c.taxa >= 80 ? '#16a34a' : c.taxa >= 50 ? '#f59e0b' : '#dc2626' }}>{c.taxa}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Mapa das semanas */}
          <div style={{ ...cartao, marginBottom: 12, overflowX: 'auto' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Mapa das semanas <span style={{ fontWeight: 400, color: '#9ca3af' }}>(cada quadradinho é um bloco da rotina)</span></div>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead><tr>
                <th></th>
                {['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'].map((d, i) => (
                  <th key={d} style={{ fontSize: 10, color: '#9ca3af', fontWeight: 700, padding: '2px 6px', textAlign: 'left' }}>{d}</th>
                ))}
              </tr></thead>
              <tbody>
                {semanasDoMapa.map(s => (
                  <tr key={s}>
                    <td style={{ fontSize: 10.5, color: '#374151', fontWeight: 700, padding: '3px 8px 3px 0', whiteSpace: 'nowrap' }}>{fmtBRc(s)}</td>
                    {Array.from({ length: 7 }, (_, i) => {
                      const dia = somarDiasIso(s, i);
                      const doDia = blocos.filter(b => b.semana === s && b.data === dia)
                        .sort((a, b) => (a.closer || '').localeCompare(b.closer || '') || (a.hora_ini || '').localeCompare(b.hora_ini || ''));
                      return (
                        <td key={i} style={{ padding: '3px 6px 3px 0', verticalAlign: 'top' }}>
                          <div style={{ display: 'flex', gap: 2, flexWrap: 'wrap', maxWidth: 90 }}>
                            {doDia.map(b => {
                              const k = classeBloco(b);
                              return <div key={b._id} title={`${b.closer.split(' ')[0]} · ${b.hora_ini}–${b.hora_fim} ${b.atividade} — ${CORES_EXEC[k].rotulo}`}
                                style={{ width: 13, height: 13, borderRadius: 3, background: CORES_EXEC[k].cor, cursor: 'default' }} />;
                            })}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 8 }}>
              {Object.values(CORES_EXEC).map(({ cor, rotulo }) => (
                <span key={rotulo} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 10.5, color: '#6b7280' }}>
                  <span style={{ width: 11, height: 11, borderRadius: 3, background: cor, display: 'inline-block' }} />{rotulo}
                </span>
              ))}
            </div>
          </div>

          {/* Série semanal */}
          {dados.serie.length > 1 && (
            <div style={{ ...cartao, marginBottom: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Evolução semanal <span style={{ fontWeight: 400, color: '#9ca3af' }}>(taxa de execução por semana)</span></div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 90 }}>
                {dados.serie.map(s => (
                  <div key={s.semana} title={`${fmtBRc(s.semana)}: ${s.feitos}/${s.planejados} blocos · ${s.taxa}%`}
                    style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <span style={{ fontSize: 10, fontWeight: 700, color: s.taxa >= 80 ? '#16a34a' : s.taxa >= 50 ? '#b45309' : '#dc2626' }}>{s.taxa}%</span>
                    <div style={{ width: '100%', maxWidth: 46, borderRadius: '3px 3px 0 0', background: s.taxa >= 80 ? '#16a34a' : s.taxa >= 50 ? '#f59e0b' : '#dc2626', height: `${Math.max(3, s.taxa * 0.6)}px`, opacity: 0.85 }} />
                    <span style={{ fontSize: 9, color: '#9ca3af', whiteSpace: 'nowrap' }}>{fmtBRc(s.semana)}</span>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>Cada barra é uma semana (a data é a segunda-feira).</div>
            </div>
          )}

          {/* Resultados anotados */}
          <div style={{ ...cartao, padding: 0, overflowX: 'auto' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', padding: '10px 12px 4px' }}>O que foi feito, bloco a bloco <span style={{ fontWeight: 400, color: '#9ca3af' }}>(anotações do closer ao concluir)</span></div>
            {dados.resultados.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: 12.5, padding: 18 }}>Nenhum desfecho dado ainda.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>
                  <th style={th}>Dia</th><th style={th}>Closer</th><th style={th}>Bloco</th><th style={th}>Desfecho</th><th style={th}>Anotação</th>
                </tr></thead>
                <tbody>
                  {dados.resultados.map((r, i) => (
                    <tr key={i} style={{ background: i % 2 ? '#fafafa' : '#fff' }}>
                      <td style={{ ...td, whiteSpace: 'nowrap', fontWeight: 600 }}>{diaSemana(r.data)} {fmtBRc(r.data)}</td>
                      <td style={td}>{(r.closer || '').split(' ')[0]}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{r.hora_ini}–{r.hora_fim} {r.atividade}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>
                        {r.status === 'feito'
                          ? <span style={{ color: r.no_horario ? '#16a34a' : '#b45309', fontWeight: 700 }}>{r.no_horario ? '✓ no horário' : '✓ fora do horário'}</span>
                          : <span style={{ color: '#dc2626', fontWeight: 700 }}>✗ não feito</span>}
                      </td>
                      <td style={{ ...td, color: r.texto ? '#374151' : '#c8d0da' }}>{r.texto || '(sem anotação)'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </div>
  );
}

/* ── Aba: Origem (só Vagner) — de onde vêm as vendas ────────────────────────
   Analisa vendas por origem de captação (origem_lead), filtra e ATRIBUI a
   origem de vendas antigas que nasceram antes da aba Origem existir (o
   seletor da linha chama PUT /vendas/:id/origem, que propaga pro pedido
   inteiro, pra oportunidade e pro cliente). */
const ORIGENS_LEAD = ['Parceiros', 'SDR', 'Ativo', 'Cliente', 'Network', 'Rede Social', 'Anúncios', 'Site'];
const COR_ORIGEM = { Parceiros: '#7c3aed', SDR: '#0369a1', Ativo: '#b45309', Cliente: '#16a34a', Network: '#0a1628', 'Rede Social': '#db2777', 'Anúncios': '#d97706', Site: '#0891b2' };

function RelatorioOrigem() {
  const [vendas, setVendas] = useState(null);
  const [ano, setAno] = useState(String(new Date().getFullYear()));
  const [filtroOrigem, setFiltroOrigem] = useState(''); // '' = todas · 'sem' · nome da origem
  const [filtroConsultor, setFiltroConsultor] = useState('');
  const [filtroServico, setFiltroServico] = useState('');
  const [salvando, setSalvando] = useState('');
  const [erro, setErro] = useState('');
  // Cadastros pro seletor "quem indicou" (a pessoa por trás da origem)
  const [pessoas, setPessoas] = useState({ Parceiros: [], Cliente: [], SDR: [] });
  const moedaBR = (n) => PRIVADO ? 'R$ •••' : `R$ ${(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;

  const carregar = useCallback(() => {
    apiFetch('/oportunidades/vendas').then(d => setVendas(d.vendas || [])).catch(e => setErro(e.message));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => {
    Promise.all([
      apiFetch('/parceiros').catch(() => []),
      apiFetch('/clientes').catch(() => []),
      apiFetch('/usuarios').catch(() => []),
    ]).then(([par, cli, usu]) => setPessoas({
      Parceiros: (Array.isArray(par) ? par : par.parceiros || []).map(x => ({ id: x._id, nome: x.nome })).sort((a, b) => a.nome.localeCompare(b.nome)),
      Cliente: (Array.isArray(cli) ? cli : cli.clientes || []).map(x => ({ id: x._id, nome: x.nome })).sort((a, b) => a.nome.localeCompare(b.nome)),
      SDR: (Array.isArray(usu) ? usu : []).filter(u => (u.cargo || '').toLowerCase() === 'sdr').map(x => ({ id: x._id, nome: x.nome })).sort((a, b) => a.nome.localeCompare(b.nome)),
    }));
  }, []);

  if (erro) return <div style={{ color: '#b91c1c', fontSize: 13 }}>Erro ao carregar: {erro}</div>;
  if (!vendas) return <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div>;

  const anos = [...new Set(vendas.map(v => (v.data_venda || '').slice(0, 4)).filter(Boolean))].sort().reverse();
  const doAno = vendas.filter(v => (v.data_venda || '').startsWith(ano));
  const consultores = [...new Set(doAno.map(v => (v.consultor || '').trim()).filter(Boolean))].sort();
  const servicos = [...new Set(doAno.map(v => (v.servico || '').trim()).filter(Boolean))].sort();
  // Vendedor e serviço filtram TUDO (ranking, chips e tabela); a origem
  // escolhida filtra só a tabela — assim o ranking sempre compara as origens
  const base = doAno.filter(v =>
    (!filtroConsultor || (v.consultor || '').trim() === filtroConsultor)
    && (!filtroServico || (v.servico || '').trim() === filtroServico));
  const nSem = base.filter(v => !(v.origem_lead || '').trim()).length;
  const totalValor = base.reduce((s, v) => s + (v.valor || 0), 0);
  const porOrigem = ORIGENS_LEAD.map(o => {
    const vs = base.filter(v => v.origem_lead === o);
    return { origem: o, qtd: vs.length, valor: vs.reduce((s, v) => s + (v.valor || 0), 0) };
  }).sort((a, b) => b.valor - a.valor);
  const maxValor = Math.max(1, ...porOrigem.map(p => p.valor));
  const filtradas = base.filter(v => !filtroOrigem
    || (filtroOrigem === 'sem' ? !(v.origem_lead || '').trim() : v.origem_lead === filtroOrigem));

  // Salva a PESSOA da origem (quem indicou) — mesma rota, mesma propagação
  async function mudarDetalhe(v, encoded) {
    if (salvando) return;
    setSalvando(v.id);
    try {
      const p = encoded ? JSON.parse(encoded) : { nome: '', id: '' };
      await apiFetch(`/oportunidades/vendas/${encodeURIComponent(v.id)}/origem`, {
        method: 'PUT', body: JSON.stringify({ origem_lead: v.origem_lead, origem_detalhe: p.nome, origem_detalhe_id: p.id }),
      });
      carregar();
    } catch (e) { alert('Não consegui salvar quem indicou: ' + e.message); }
    setSalvando('');
  }

  async function mudarOrigem(v, nova) {
    if (!nova || salvando) return;
    setSalvando(v.id);
    try {
      await apiFetch(`/oportunidades/vendas/${encodeURIComponent(v.id)}/origem`, {
        method: 'PUT', body: JSON.stringify({ origem_lead: nova }),
      });
      carregar(); // o servidor propaga pro pedido/oportunidade/cliente — recarrega pra refletir
    } catch (e) { alert('Não consegui salvar a origem: ' + e.message); }
    setSalvando('');
  }

  const chip = (ativo, cor) => ({
    padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: 'pointer',
    border: `1px solid ${ativo ? (cor || '#0a1628') : '#d1d5db'}`,
    background: ativo ? (cor || '#0a1628') : '#fff', color: ativo ? '#fff' : '#374151',
  });

  return (
    <div>
      {/* Filtros */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
        <select value={ano} onChange={e => setAno(e.target.value)} style={{ ...inp, height: 30, fontWeight: 700 }}>
          {(anos.length ? anos : [ano]).map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <button onClick={() => setFiltroOrigem('')} style={chip(!filtroOrigem)}>Todas ({base.length})</button>
        <button onClick={() => setFiltroOrigem('sem')} style={chip(filtroOrigem === 'sem', '#b45309')}>
          ⚠️ Sem origem ({nSem})
        </button>
        {ORIGENS_LEAD.map(o => {
          const n = base.filter(v => v.origem_lead === o).length;
          return <button key={o} onClick={() => setFiltroOrigem(o)} style={chip(filtroOrigem === o, COR_ORIGEM[o])}>{o} ({n})</button>;
        })}
      </div>
      {/* Vendedor e serviço (contagens cruzadas: cada linha respeita a outra) */}
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 6 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>Vendedor:</span>
        <button onClick={() => setFiltroConsultor('')} style={chip(!filtroConsultor)}>Todos</button>
        {consultores.map(c => {
          const n = doAno.filter(v => (v.consultor || '').trim() === c && (!filtroServico || (v.servico || '').trim() === filtroServico)).length;
          return <button key={c} onClick={() => setFiltroConsultor(filtroConsultor === c ? '' : c)} style={chip(filtroConsultor === c, '#1d4ed8')}>{c.split(/\s+/)[0]} ({n})</button>;
        })}
      </div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 14 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>Serviço:</span>
        <select value={filtroServico} onChange={e => setFiltroServico(e.target.value)}
          style={{ ...inp, height: 30, minWidth: 220, fontWeight: filtroServico ? 700 : 400, color: filtroServico ? '#0f766e' : '#374151' }}>
          <option value="">Todos os serviços ({doAno.filter(v => !filtroConsultor || (v.consultor || '').trim() === filtroConsultor).length})</option>
          {servicos.map(s => {
            const n = doAno.filter(v => (v.servico || '').trim() === s && (!filtroConsultor || (v.consultor || '').trim() === filtroConsultor)).length;
            return <option key={s} value={s}>{s} ({n})</option>;
          })}
        </select>
        {filtroServico && <button onClick={() => setFiltroServico('')} style={chip(false)}>× limpar</button>}
      </div>

      {/* Ranking por origem */}
      <div style={{ background: '#fff', border: '1px solid #dbe2ea', borderRadius: 8, padding: '12px 16px', marginBottom: 14 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 8 }}>
          Vendas por origem em {ano} · total {moedaBR(totalValor)}
        </div>
        {porOrigem.map(p => (
          <div key={p.origem} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 5 }}>
            <span style={{ width: 92, fontSize: 12, fontWeight: 700, color: '#0a1628', flexShrink: 0 }}>{p.origem}</span>
            <div style={{ flex: 1, background: '#f1f5f9', borderRadius: 4, height: 18, overflow: 'hidden' }}>
              <div style={{ width: `${(p.valor / maxValor) * 100}%`, minWidth: p.valor > 0 ? 4 : 0, height: '100%', background: COR_ORIGEM[p.origem], opacity: 0.85 }} />
            </div>
            <span style={{ width: 150, fontSize: 12, color: '#374151', textAlign: 'right', flexShrink: 0 }}>
              {p.qtd} venda(s) · <strong>{moedaBR(p.valor)}</strong>{totalValor > 0 ? ` · ${Math.round(p.valor / totalValor * 100)}%` : ''}
            </span>
          </div>
        ))}
        {nSem > 0 && (
          <div style={{ marginTop: 8, fontSize: 12, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '6px 10px' }}>
            ⚠️ {nSem} venda(s) de {ano} ainda sem origem — clique em “Sem origem” acima e atribua na coluna Origem da tabela.
          </div>
        )}
      </div>

      {/* Tabela com edição inline */}
      <div style={{ border: '1px solid #c8d0da', borderRadius: 6, overflowX: 'auto', background: '#fff' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 760 }}>
          <thead><tr>{['Data', 'Cliente', 'Consultor', 'Serviço', 'Valor', 'Origem', 'Quem indicou'].map((h, i) => (
            <th key={h} style={{ ...th, textAlign: i === 4 ? 'right' : 'left' }}>{h}</th>
          ))}</tr></thead>
          <tbody>
            {filtradas.map(v => {
              const sem = !(v.origem_lead || '').trim();
              return (
                <tr key={v.id} style={{ background: sem ? '#fffbeb' : '#fff' }}>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{(v.data_venda || '').split('-').reverse().join('/')}</td>
                  <td style={{ ...td, fontWeight: 600 }}>
                    {v.cliente_id ? <Link to={`/clientes/${v.cliente_id}/editar`} style={{ color: '#1d4ed8' }}>{v.cliente}</Link> : v.cliente}
                  </td>
                  <td style={td}>{(v.consultor || '').trim().split(/\s+/)[0] || '—'}</td>
                  <td style={{ ...td, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={v.servico}>{v.servico || '—'}</td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: '#15803d', whiteSpace: 'nowrap' }}>{moedaBR(v.valor)}</td>
                  <td style={td}>
                    <select value={v.origem_lead || ''} disabled={salvando === v.id}
                      onChange={e => mudarOrigem(v, e.target.value)}
                      title="Trocar aqui grava na hora — vale pro pedido inteiro, pra oportunidade e pro cliente"
                      style={{ ...inp, height: 26, fontWeight: 700, minWidth: 120, color: sem ? '#b45309' : (COR_ORIGEM[v.origem_lead] || '#111'), borderColor: sem ? '#f59e0b' : '#b0b8c4', cursor: salvando === v.id ? 'wait' : 'pointer' }}>
                      <option value="">— definir —</option>
                      {ORIGENS_LEAD.map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                  </td>
                  <td style={{ ...td, fontSize: 12, color: '#6b7280', minWidth: 170 }}>
                    {['Parceiros', 'Cliente', 'SDR'].includes(v.origem_lead) ? (() => {
                      const lista = pessoas[v.origem_lead] || [];
                      const atualNaLista = lista.some(pp => pp.nome === v.origem_detalhe);
                      return (
                        <select disabled={salvando === v.id}
                          value={v.origem_detalhe ? JSON.stringify({ nome: v.origem_detalhe, id: v.origem_detalhe_id || (lista.find(pp => pp.nome === v.origem_detalhe)?.id || '') }) : ''}
                          onChange={e => mudarDetalhe(v, e.target.value)}
                          title="Quem indicou — trocar aqui grava na hora e vale pro pedido, pra oportunidade e pro cliente"
                          style={{ ...inp, height: 26, fontSize: 12, minWidth: 160, maxWidth: 210, color: v.origem_detalhe ? '#111' : '#b45309', borderColor: v.origem_detalhe ? '#b0b8c4' : '#f59e0b', cursor: salvando === v.id ? 'wait' : 'pointer' }}>
                          <option value="">— escolher —</option>
                          {!atualNaLista && v.origem_detalhe && <option value={JSON.stringify({ nome: v.origem_detalhe, id: v.origem_detalhe_id || '' })}>{v.origem_detalhe}</option>}
                          {lista.map(pp => <option key={pp.id} value={JSON.stringify({ nome: pp.nome, id: pp.id })}>{pp.nome}</option>)}
                        </select>
                      );
                    })() : (v.origem_detalhe || '—')}
                  </td>
                </tr>
              );
            })}
            {filtradas.length === 0 && <tr><td colSpan={7} style={{ ...td, textAlign: 'center', color: '#9ca3af', padding: 20 }}>Nenhuma venda nesse filtro.</td></tr>}
          </tbody>
        </table>
      </div>
      <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 8 }}>
        Trocar a origem numa linha atualiza o pedido inteiro (venda multi-produto), a oportunidade e o cliente (se ele ainda não tiver origem). Vendas novas já nascem com origem pela aba obrigatória do Gravar Cliente.
      </div>
    </div>
  );
}

/* ── Central de Relatórios ── */
// ═══════════════ 🌡️ MERCADO — sazonalidade das movimentações do INPI ═══════
// Mapa de calor no mesmo modelo do faturamento, mas com a base da RPI
// (5,1M de marcas): publicado/deferimento/indeferimento/concessão nos
// últimos 5 anos. O servidor mantém tudo pré-calculado por revista, então
// abrir a aba e trocar de marco é instantâneo.
const MARCOS_MERCADO = [
  { key: 'publicado',      rotulo: '📢 Publicado',      desc: 'pedidos publicados para oposição (nacional + Madri)' },
  { key: 'deferimento',    rotulo: '✅ Deferimento',    desc: 'pedidos aprovados no exame' },
  { key: 'indeferimento',  rotulo: '❌ Indeferimento',  desc: 'pedidos negados no exame' },
  { key: 'concessao',      rotulo: '🏆 Concessão',      desc: 'registros expedidos (certificado emitido)' },
  { key: 'extincao',       rotulo: '⛔ Extinção',       desc: 'registros extintos (vigência expirada + caducidade)' },
];

// Sub-abas do Mercado: mapa de calor + evolução ano a ano dos marcos.
// fonte='geral' = INPI inteiro; fonte='preserva' = só os processos com a
// Preserva (Vagner Pereira de Freitas) como procuradora
function RelatorioMercadoInpi({ fonte = 'geral', dadosProntos = null, rotuloProprio = '' }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [marco, setMarco] = useState('publicado');
  // Mouse em cima de um ano na legenda → a linha dele salta e as outras somem
  const [anoDestaque, setAnoDestaque] = useState(null);
  // Modo avulso: qualquer procurador digitado
  const [buscaProc, setBuscaProc] = useState('');
  const [dadosAvulso, setDadosAvulso] = useState(null);
  const [buscandoProc, setBuscandoProc] = useState(false);

  async function buscarAvulso() {
    if (buscaProc.trim().length < 4) return alert('Digite ao menos 4 letras do nome do procurador.');
    setBuscandoProc(true);
    try {
      const d = await apiFetch(`/marcas-rpi/mercado/avulso?procurador=${encodeURIComponent(buscaProc.trim())}`);
      setDadosAvulso(d);
    } catch (e) { alert('Busca falhou: ' + e.message); }
    setBuscandoProc(false);
  }

  useEffect(() => {
    // Modo "dados prontos": o Comparativo entrega os marcos já buscados —
    // nada de fetch nem de polling, só renderizar
    if (dadosProntos) { setDados({ marcos: dadosProntos, construindo: false }); return undefined; }
    let vivo = true;
    let timer = null;
    const carregar = () => apiFetch('/marcas-rpi/mercado/sazonalidade')
      .then(d => {
        if (!vivo) return;
        setDados(d);
        // Primeira construção ainda rodando? Atualiza sozinho a cada 15s
        // pro mapa ir se completando na tela
        if (d.construindo) timer = setTimeout(carregar, 15000);
      })
      .catch(e => vivo && setErro(e.message));
    carregar();
    return () => { vivo = false; clearTimeout(timer); };
  }, [dadosProntos]);

  if (erro) return <div style={{ color: '#dc2626', fontSize: 13, padding: 12 }}>Erro ao carregar: {erro}</div>;
  if (!dados) return <div style={{ color: '#6b7280', fontSize: 13, padding: 12 }}>Carregando o mercado…</div>;

  const FAIXAS_CALOR = [
    { min: 0.8, bg: '#16a34a', fg: '#fff', rotulo: '80–100% (melhor)' },
    { min: 0.6, bg: '#86efac', fg: '#14532d', rotulo: '60–80%' },
    { min: 0.4, bg: '#fde047', fg: '#713f12', rotulo: '40–60%' },
    { min: 0.2, bg: '#fdba74', fg: '#7c2d12', rotulo: '20–40%' },
    { min: 0, bg: '#fca5a5', fg: '#7f1d1d', rotulo: 'até 20% (fraco)' },
  ];
  const corCel = (v, maxAno) => {
    if (v <= 0) return { bg: '#f8fafc', fg: '#374151' };
    const p = v / Math.max(1, maxAno);
    return FAIXAS_CALOR.find(f => p >= f.min) || FAIXAS_CALOR[FAIXAS_CALOR.length - 1];
  };

  const porAno = (fonte === 'avulso' ? dadosAvulso?.marcos?.[marco]
    : fonte === 'preserva' ? dados.preserva?.[marco] : dados.marcos?.[marco]) || {};
  const anos = Object.keys(porAno).map(Number).sort((a, b) => b - a); // recente em cima
  const infoMarco = MARCOS_MERCADO.find(m => m.key === marco);
  const TRI_BORDA = '2px solid #94a3b8';
  const mesAtual = { ano: new Date().getFullYear(), mes: new Date().getMonth() };
  const secao = { background: '#fff', border: '1px solid #dbe2ea', borderRadius: 10, padding: '12px 16px' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {/* Aviso de primeira construção */}
      {dados.construindo && (
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '8px 14px', fontSize: 12.5, color: '#1d4ed8' }}>
          ⏳ Contando as revistas da biblioteca ({dados.progresso ? `${dados.progresso.feitas} de ${dados.progresso.total}` : '…'}) —
          o mapa vai se completando sozinho; depois desta primeira vez, fica sempre pronto.
        </div>
      )}

      {/* Busca do modo avulso */}
      {fonte === 'avulso' && (
        <div style={{ background: '#fff', border: '1px solid #dbe2ea', borderRadius: 10, padding: '12px 16px' }}>
          <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>🔎 Qual procurador você quer analisar?</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input value={buscaProc} onChange={e => setBuscaProc(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && buscarAvulso()}
              placeholder="Ex: DANIEL ADVOGADOS, MONTAURY, parte do nome já serve…"
              style={{ flex: 1, minWidth: 240, padding: '7px 10px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13 }} />
            <button onClick={buscarAvulso} disabled={buscandoProc}
              style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: buscandoProc ? 0.6 : 1 }}>
              {buscandoProc ? '⏳ Contando…' : 'Buscar'}
            </button>
          </div>
          {dadosAvulso && (
            <div style={{ fontSize: 11.5, color: '#374151', marginTop: 8 }}>
              {dadosAvulso.grafias?.length
                ? <>Somando <b>{dadosAvulso.grafias.length >= 6 ? '6+' : dadosAvulso.grafias.length}</b> grafia(s): {dadosAvulso.grafias.slice(0, 4).join(' · ')}{dadosAvulso.grafias.length > 4 ? '…' : ''} — <b>{(dadosAvulso.total_movimentos || 0).toLocaleString('pt-BR')}</b> movimentações no período</>
                : <span style={{ color: '#b45309' }}>Nenhum procurador com esse nome no índice — confira a grafia.</span>}
            </div>
          )}
        </div>
      )}

      {/* Filtro de marco + painéis: no avulso, só depois de uma busca */}
      {(fonte !== 'avulso' || dadosAvulso) && (<>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {MARCOS_MERCADO.map(m => (
          <button key={m.key} onClick={() => setMarco(m.key)}
            style={{
              padding: '6px 14px', fontSize: 12.5, fontWeight: marco === m.key ? 700 : 500,
              background: marco === m.key ? '#0a1628' : '#fff', color: marco === m.key ? '#fff' : '#374151',
              border: `1px solid ${marco === m.key ? '#0a1628' : '#c8d0da'}`, borderRadius: 20, cursor: 'pointer',
            }}>
            {m.rotulo}
          </button>
        ))}
      </div>

      {/* Heatmap */}
      <div style={secao}>
        <div style={{ fontSize: 13, fontWeight: 800, color: '#0a1628', marginBottom: 2 }}>
          🌡️ Mapa de calor — {infoMarco?.rotulo.replace(/^\S+\s/, '')} mês a mês {rotuloProprio ? `— ${rotuloProprio}` : fonte === 'preserva' ? 'da Preserva Marcas' : fonte === 'avulso' ? `de "${buscaProc.trim().toUpperCase()}"` : 'no INPI'}
        </div>
        <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8 }}>
          {infoMarco?.desc}{fonte === 'preserva' ? ' · só processos com procurador VAGNER PEREIRA DE FREITAS' : fonte === 'avulso' ? ' · só processos do(s) procurador(es) buscado(s)' : ''}
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
          {[...FAIXAS_CALOR].reverse().map(f => (
            <span key={f.rotulo} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 10.5, color: '#374151' }}>
              <span style={{ width: 14, height: 14, background: f.bg, borderRadius: 3, border: '1px solid rgba(0,0,0,0.08)' }} />
              {f.rotulo}
            </span>
          ))}
          <span style={{ fontSize: 10.5, color: '#9ca3af' }}>· % em relação ao melhor mês do próprio ano</span>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 640 }}>
            <thead>
              <tr>
                <th style={{ padding: '2px 6px' }}></th>
                {MESES_CURTOS.map(m => <th key={m} style={{ fontSize: 10, color: '#6b7280', padding: '2px 4px' }}>{m}</th>)}
                <th style={{ fontSize: 10, color: '#0a1628', fontWeight: 800, padding: '2px 6px' }}>TOTAL</th>
              </tr>
              <tr>
                <th></th>
                {[1, 2, 3, 4].map(t => (
                  <th key={t} colSpan={3}
                    style={{ fontSize: 9.5, fontWeight: 800, color: '#475569', letterSpacing: 1, background: '#f1f5f9', padding: '3px 0', borderTop: TRI_BORDA, borderLeft: TRI_BORDA, borderRight: TRI_BORDA }}>
                    {t}º TRI
                  </th>
                ))}
                <th style={{ fontSize: 9.5, fontWeight: 800, color: '#475569', letterSpacing: 1, background: '#f1f5f9', padding: '3px 6px', borderTop: TRI_BORDA, borderLeft: TRI_BORDA, borderRight: TRI_BORDA }}>Σ ANO</th>
              </tr>
            </thead>
            <tbody>
              {anos.map((ano, r) => {
                const meses = porAno[ano] || Array(12).fill(0);
                // Mês corrente ainda incompleto não entra na régua do ano
                // (senão agosto pela metade rebaixa a cor dos meses cheios)
                const completos = meses.filter((v, k) => !(ano === mesAtual.ano && k >= mesAtual.mes));
                const maxAno = Math.max(1, ...completos);
                const ultimaLinha = r === anos.length - 1;
                return (
                  <tr key={ano}>
                    <td style={{ fontSize: 11.5, fontWeight: 800, color: '#0a1628', padding: '2px 6px', whiteSpace: 'nowrap' }}>{ano}</td>
                    {meses.map((v, k) => {
                      const parcial = ano === mesAtual.ano && k === mesAtual.mes;
                      const futuro = ano === mesAtual.ano && k > mesAtual.mes;
                      const c = futuro ? { bg: '#fff', fg: '#9ca3af' } : corCel(v, maxAno);
                      return (
                        <td key={k}
                          title={`${MESES_CURTOS[k]}/${ano} (${Math.floor(k / 3) + 1}º tri): ${v ? v.toLocaleString('pt-BR') + ' movimentações' : 'sem dado'}${parcial ? ' — mês em andamento' : ''}${v > 0 && !futuro ? ` (${Math.round(v / maxAno * 100)}% do melhor mês de ${ano})` : ''}`}
                          style={{
                            background: c.bg, textAlign: 'center', fontSize: 9.5, fontWeight: 700,
                            color: c.fg, padding: '7px 2px', opacity: parcial ? 0.55 : 1,
                            borderTop: '2px solid #fff',
                            borderLeft: k % 3 === 0 ? TRI_BORDA : '2px solid #fff',
                            borderRight: k % 3 === 2 ? TRI_BORDA : '2px solid #fff',
                            borderBottom: ultimaLinha ? TRI_BORDA : '2px solid #fff',
                          }}>
                          {v > 0 ? abreviaValor(v) : ''}{parcial ? '…' : ''}
                        </td>
                      );
                    })}
                    {(() => {
                      const totalAno = meses.reduce((s, v) => s + (v || 0), 0);
                      const anoAberto = ano === mesAtual.ano;
                      return (
                        <td title={`Total de ${ano}: ${totalAno.toLocaleString('pt-BR')} movimentações${anoAberto ? ' (ano em andamento)' : ''}`}
                          style={{ textAlign: 'center', fontSize: 10, fontWeight: 800, color: '#0a1628', background: '#f8fafc', padding: '7px 4px', borderLeft: TRI_BORDA, borderRight: TRI_BORDA, borderTop: '2px solid #fff', borderBottom: ultimaLinha ? TRI_BORDA : '2px solid #fff', whiteSpace: 'nowrap' }}>
                          {totalAno > 0 ? abreviaValor(totalAno) : ''}{anoAberto && totalAno > 0 ? '…' : ''}
                        </td>
                      );
                    })()}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 6 }}>
          Fonte: biblioteca de RPIs do sistema · atualizado até a revista {dados.ultima_rpi || '—'}{dados.ultima_data ? ` (${dados.ultima_data})` : ''} ·
          o mês em andamento aparece esmaecido com "…" e fica fora da régua de cores do ano
        </div>
      </div>

      {/* Evolução ano a ano — mesmas linhas do dashboard do faturamento,
          uma cor por ano; a linha do ano atual para no último mês FECHADO
          (o mês em andamento tem menos revistas contadas e afundaria a linha) */}
      <div style={secao}>
        <div style={{ fontSize: 13, fontWeight: 800, color: '#0a1628', marginBottom: 8 }}>
          📈 Evolução ano a ano — {infoMarco?.rotulo.replace(/^\S+\s/, '')} por mês
        </div>
        {(() => {
          const W = 760, H = 210, PAD = 46;
          const anosAsc = [...anos].sort((a, b) => a - b);
          const series = anosAsc.map(ano => ({
            ano,
            pontos: (porAno[ano] || []).map((v, k) => ({ m: k + 1, v }))
              .filter(p => p.v > 0 && !(ano === mesAtual.ano && p.m - 1 >= mesAtual.mes)),
          }));
          const maxV = Math.max(1, ...series.flatMap(s => s.pontos.map(p => p.v)));
          const x = (m) => PAD + ((m - 1) / 11) * (W - PAD - 10);
          const y = (v) => H - 26 - (v / maxV) * (H - 44);
          const corAno = (ano) => COR_ANO[ano] || '#6b7280';
          return (
            <>
              <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
                {[0.25, 0.5, 0.75, 1].map(f => (
                  <g key={f}>
                    <line x1={PAD} x2={W - 10} y1={y(maxV * f)} y2={y(maxV * f)} stroke="#eef2f7" strokeWidth="1" />
                    <text x={PAD - 4} y={y(maxV * f) + 3} textAnchor="end" fontSize="8.5" fill="#9ca3af">{abreviaValor(Math.round(maxV * f))}</text>
                  </g>
                ))}
                {MESES_CURTOS.map((r, k) => <text key={r} x={x(k + 1)} y={H - 10} textAnchor="middle" fontSize="8.5" fill="#6b7280">{r}</text>)}
                {series.map(s => {
                  if (!s.pontos.length) return null;
                  // Com um ano destacado, ele domina e os demais viram fantasma
                  const destaque = anoDestaque !== null;
                  const ehEle = s.ano === anoDestaque;
                  const grossura = destaque ? (ehEle ? 3.6 : 1.2) : (s.ano === mesAtual.ano ? 3 : 1.8);
                  const alfa = destaque ? (ehEle ? 1 : 0.12) : (s.ano === mesAtual.ano ? 1 : 0.75);
                  return (
                    <g key={s.ano} style={{ transition: 'opacity 0.15s' }} opacity={alfa}>
                      <polyline fill="none" stroke={corAno(s.ano)} strokeWidth={grossura}
                        points={s.pontos.map(p => `${x(p.m)},${y(p.v)}`).join(' ')} />
                      {s.pontos.map(p => (
                        <circle key={p.m} cx={x(p.m)} cy={y(p.v)} r={(destaque ? ehEle : s.ano === mesAtual.ano) ? 3.4 : 2} fill={corAno(s.ano)}>
                          <title>{`${MESES_CURTOS[p.m - 1]}/${s.ano}: ${p.v.toLocaleString('pt-BR')}`}</title>
                        </circle>
                      ))}
                    </g>
                  );
                })}
              </svg>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
                {anosAsc.map(a => (
                  <span key={a}
                    onMouseEnter={() => setAnoDestaque(a)}
                    onMouseLeave={() => setAnoDestaque(null)}
                    title={`Destacar a linha de ${a}`}
                    style={{
                      fontSize: 11.5, fontWeight: a === (anoDestaque ?? mesAtual.ano) ? 800 : 600, color: corAno(a),
                      cursor: 'default', padding: '2px 8px', borderRadius: 12,
                      background: a === anoDestaque ? '#f1f5f9' : 'transparent',
                      opacity: anoDestaque !== null && a !== anoDestaque ? 0.35 : 1,
                    }}>
                    ― {a}
                  </span>
                ))}
              </div>
              <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>
                A linha de {mesAtual.ano} vai até o último mês fechado — {MESES_CURTOS[mesAtual.mes] || ''} ainda está em andamento e entraria pela metade.
              </div>
            </>
          );
        })()}
      </div>
      </>)}
    </div>
  );
}

// 🌡️ MERCADO — contêiner com sub-abas: INPI é a primeira; futuras fontes
// de leitura de mercado (Receita, Google Trends…) entram como novas sub-abas
// ⚔️ Sub-aba COMPARATIVO: até 5 procuradores lado a lado — corrida mensal,
// ranking, fatia de mercado, aproveitamento, crescimento YoY e sazonalidade
// normalizada. Tudo client-side em cima do /avulso (1 chamada por procurador)
// + o total do INPI que o /sazonalidade já entrega.
const CORES_COMP = ['#1d4ed8', '#dc2626', '#16a34a', '#7c3aed', '#ea580c'];

function RelatorioMercadoComparativo() {
  const [geral, setGeral] = useState(null);
  const [busca, setBusca] = useState('');
  const [adicionando, setAdicionando] = useState(false);
  const [comparados, setComparados] = useState([]);
  const [marco, setMarco] = useState('publicado');
  const [periodo, setPeriodo] = useState('5anos');
  const [destaque, setDestaque] = useState(null);
  // 🗺️ Dashboards individuais: qual participante está com o mapa aberto
  const [detalhe, setDetalhe] = useState(null);

  useEffect(() => { apiFetch('/marcas-rpi/mercado/sazonalidade').then(setGeral).catch(() => {}); }, []);

  const hoje = new Date();
  const anoAtu = hoje.getFullYear();
  const mesAtu = hoje.getMonth(); // 0-index: mês corrente (parcial, fica fora das curvas)
  const ANOS5 = [anoAtu - 4, anoAtu - 3, anoAtu - 2, anoAtu - 1, anoAtu];

  async function adicionar(nomeFixo) {
    const n = String(nomeFixo ?? busca).trim();
    if (n.length < 4) return alert('Digite ao menos 4 letras do nome.');
    if (comparados.filter(c => !c.ehInpi).length >= 5) return alert('Máximo de 5 procuradores — remova um pra adicionar outro (o INPI não conta no limite).');
    if (comparados.some(c => c.nome === n.toUpperCase())) return;
    setAdicionando(true);
    try {
      const d = await apiFetch(`/marcas-rpi/mercado/avulso?procurador=${encodeURIComponent(n)}`);
      if (!d.grafias?.length) alert(`Nenhum procurador com "${n}" no índice — confira a grafia.`);
      else {
        const cor = CORES_COMP.find(cc => !comparados.some(x => x.cor === cc)) || '#6b7280';
        setComparados(c => [...c, { nome: n.toUpperCase(), grafias: d.grafias, marcos: d.marcos, cor }]);
        setBusca('');
      }
    } catch (e) { alert('Busca falhou: ' + e.message); }
    setAdicionando(false);
  }

  // 💾 Comparações salvas (localStorage): monta a briga favorita com 1 clique
  const [salvas, setSalvas] = useState(() => { try { return JSON.parse(localStorage.getItem('mercado_comp_salvas') || '[]'); } catch { return []; } });
  function salvarComparacao() {
    if (comparados.length < 2) return alert('Monte a comparação primeiro (2+ participantes).');
    const nome = window.prompt('Nome desta comparação (ex.: Concorrentes PB):');
    if (!nome?.trim()) return;
    const novas = [...salvas.filter(x => x.nome !== nome.trim()), { nome: nome.trim(), itens: comparados.map(c => c.ehInpi ? '@INPI' : c.nome) }];
    setSalvas(novas); localStorage.setItem('mercado_comp_salvas', JSON.stringify(novas));
  }
  async function carregarComparacao(cj) {
    setComparados([]);
    for (const item of cj.itens) {
      if (item === '@INPI') { adicionarInpi(); continue; }
      // eslint-disable-next-line no-await-in-loop
      await adicionar(item);
    }
  }
  function excluirComparacao(nome) {
    const novas = salvas.filter(x => x.nome !== nome);
    setSalvas(novas); localStorage.setItem('mercado_comp_salvas', JSON.stringify(novas));
  }

  // 🏛️ INPI inteiro como régua: linha tracejada, fora do limite de 5
  function adicionarInpi() {
    if (!geral?.marcos) return alert('O total do INPI ainda está carregando — tente em instantes.');
    if (comparados.some(c => c.ehInpi)) return;
    setComparados(c => [...c, { nome: 'INPI (MERCADO INTEIRO)', grafias: ['soma de todos os procuradores do INPI'], marcos: geral.marcos, cor: '#475569', ehInpi: true }]);
  }

  // Série mensal contínua (5 anos emendados), cortada no último mês fechado
  const serieCont = (marcos) => {
    const pts = [];
    for (const ano of ANOS5) {
      for (let m = 0; m < 12; m++) {
        if (ano === anoAtu && m >= mesAtu) break;
        pts.push(marcos?.[marco]?.[ano]?.[m] || 0);
      }
    }
    return pts;
  };
  const totalPeriodo = (marcos, k) => {
    const anos = periodo === '5anos' ? ANOS5 : [parseInt(periodo, 10)];
    let t = 0;
    for (const a of anos) for (const v of (marcos?.[k]?.[a] || [])) t += v;
    return t;
  };

  // Gráfico de linhas genérico do comparativo (X = meses corridos)
  const nMeses = serieCont({}).length || 1;
  const grafLinhas = (series, fmtY) => {
    const W = 760, H = 210, PAD = 46;
    const maxV = Math.max(1, ...series.flatMap(s => s.pontos));
    const x = (i) => PAD + (i / Math.max(1, nMeses - 1)) * (W - PAD - 10);
    const y = (v) => H - 26 - (v / maxV) * (H - 44);
    const idxAnos = ANOS5.map((a, k) => ({ a, i: k * 12 })).filter(o => o.i < nMeses);
    return (
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
        {[0.25, 0.5, 0.75, 1].map(f => (
          <g key={f}>
            <line x1={PAD} x2={W - 10} y1={y(maxV * f)} y2={y(maxV * f)} stroke="#eef2f7" strokeWidth="1" />
            <text x={PAD - 4} y={y(maxV * f) + 3} textAnchor="end" fontSize="8.5" fill="#9ca3af">{fmtY(maxV * f)}</text>
          </g>
        ))}
        {idxAnos.map(o => (
          <g key={o.a}>
            <line x1={x(o.i)} x2={x(o.i)} y1={y(maxV)} y2={H - 24} stroke="#e2e8f0" strokeWidth="1" strokeDasharray="3 3" />
            <text x={x(o.i)} y={H - 10} textAnchor="start" fontSize="9" fill="#6b7280" fontWeight="700">{o.a}</text>
          </g>
        ))}
        {series.map((s, si) => {
          const ativo = destaque === null || destaque === si;
          return (
            <g key={si} opacity={ativo ? 1 : 0.12}>
              <polyline fill="none" stroke={s.cor} strokeWidth={destaque === si ? 3.2 : 2}
                strokeDasharray={s.tracejada ? '7 5' : undefined}
                points={s.pontos.map((v, i) => `${x(i)},${y(v)}`).join(' ')} />
            </g>
          );
        })}
      </svg>
    );
  };

  const legenda = (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
      {comparados.map((c, i) => (
        <span key={c.nome} onMouseEnter={() => setDestaque(i)} onMouseLeave={() => setDestaque(null)}
          style={{ fontSize: 11.5, fontWeight: 700, color: c.cor, padding: '2px 8px', borderRadius: 12, background: destaque === i ? '#f1f5f9' : 'transparent', opacity: destaque !== null && destaque !== i ? 0.35 : 1, cursor: 'default' }}>
          {c.ehInpi ? '┄' : '―'} {c.nome}
        </span>
      ))}
    </div>
  );

  const secao = { background: '#fff', border: '1px solid #dbe2ea', borderRadius: 10, padding: '12px 16px' };
  const tituloSec = { fontSize: 13, fontWeight: 800, color: '#0a1628', marginBottom: 8 };
  const infoMarco = MARCOS_MERCADO.find(m => m.key === marco);
  const rotuloMarco = infoMarco?.rotulo.replace(/^\S+\s/, '') || '';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {/* Seletor de procuradores */}
      <div style={secao}>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>⚔️ Quem entra na comparação? (até 5)</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: comparados.length ? 8 : 0 }}>
          <input value={busca} onChange={e => setBusca(e.target.value)} onKeyDown={e => e.key === 'Enter' && adicionar()}
            placeholder="Nome do procurador (4+ letras)…"
            style={{ flex: 1, minWidth: 220, padding: '7px 10px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13 }} />
          <button onClick={() => adicionar()} disabled={adicionando}
            style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: adicionando ? 0.6 : 1 }}>
            {adicionando ? '⏳' : '+ Adicionar'}
          </button>
          {!comparados.some(c => c.ehInpi) && (
            <button onClick={adicionarInpi}
              style={{ background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', borderRadius: 6, padding: '7px 12px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
              🏛️ + INPI (parâmetro)
            </button>
          )}
          {!comparados.some(c => c.nome.includes('VAGNER PEREIRA')) && (
            <button onClick={() => adicionar('VAGNER PEREIRA DE FREITAS')} disabled={adicionando}
              style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 6, padding: '7px 12px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
              🛡️ + Preserva
            </button>
          )}
        </div>
        {(salvas.length > 0 || comparados.length >= 2) && (
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
            {comparados.length >= 2 && (
              <button onClick={salvarComparacao} style={{ background: '#fff', color: '#0a1628', border: '1px dashed #94a3b8', borderRadius: 14, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>💾 Salvar esta comparação</button>
            )}
            {salvas.map(cj => (
              <span key={cj.nome} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#f8fafc', border: '1px solid #dbe2ea', borderRadius: 14, padding: '3px 10px', fontSize: 11.5, fontWeight: 600, color: '#334155' }}>
                <span onClick={() => carregarComparacao(cj)} title={cj.itens.join(' · ')} style={{ cursor: 'pointer' }}>📂 {cj.nome}</span>
                <span onClick={() => excluirComparacao(cj.nome)} style={{ cursor: 'pointer', color: '#9ca3af' }}>×</span>
              </span>
            ))}
          </div>
        )}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {comparados.map((c, i) => (
            <span key={c.nome} title={`Somando: ${c.grafias.join(' · ')}`}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fff', border: `2px ${c.ehInpi ? 'dashed' : 'solid'} ${c.cor}`, color: c.cor, borderRadius: 16, padding: '3px 10px', fontSize: 12, fontWeight: 700 }}>
              {c.nome}
              <span onClick={() => setComparados(l => l.filter(x => x.nome !== c.nome))} style={{ cursor: 'pointer', fontWeight: 800 }}>×</span>
            </span>
          ))}
        </div>
      </div>

      {comparados.length < 2 ? (
        <div style={{ color: '#6b7280', fontSize: 13, padding: '4px 2px' }}>Adicione pelo menos 2 procuradores pra comparação começar. Dica: o botão 🛡️ coloca a Preserva na disputa.</div>
      ) : (<>
        {/* Filtros compartilhados */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          {MARCOS_MERCADO.filter(m => m.key !== 'extincao').map(m => (
            <button key={m.key} onClick={() => setMarco(m.key)}
              style={{ padding: '5px 12px', fontSize: 12, fontWeight: marco === m.key ? 700 : 500, background: marco === m.key ? '#0a1628' : '#fff', color: marco === m.key ? '#fff' : '#374151', border: `1px solid ${marco === m.key ? '#0a1628' : '#c8d0da'}`, borderRadius: 20, cursor: 'pointer' }}>
              {m.rotulo}
            </button>
          ))}
          <span style={{ width: 1, height: 20, background: '#dbe2ea', margin: '0 4px' }} />
          {['5anos', ...ANOS5.map(String)].map(p => (
            <button key={p} onClick={() => setPeriodo(p)}
              style={{ padding: '4px 10px', fontSize: 11.5, fontWeight: periodo === p ? 700 : 500, background: periodo === p ? '#334155' : '#eef2f7', color: periodo === p ? '#fff' : '#475569', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
              {p === '5anos' ? '5 anos' : p}
            </button>
          ))}
        </div>

        {/* 1. Corrida mensal */}
        <div style={secao}>
          <div style={tituloSec}>📈 Corrida mensal — {rotuloMarco} (5 anos corridos)</div>
          {grafLinhas(comparados.map((c) => ({ cor: c.cor, tracejada: c.ehInpi, pontos: serieCont(c.marcos) })), v => abreviaValor(Math.round(v)))}
          {legenda}
        </div>

        {/* 2. Ranking + 4. Aproveitamento */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 12 }}>
          <div style={secao}>
            <div style={tituloSec}>🥇 Ranking — {rotuloMarco} no período ({periodo === '5anos' ? '5 anos' : periodo})</div>
            {(() => {
              const linhas = comparados.map((c) => ({ nome: c.nome, cor: c.cor, v: totalPeriodo(c.marcos, marco) })).sort((a, b) => b.v - a.v);
              const max = Math.max(1, ...linhas.map(l => l.v));
              return linhas.map(l => (
                <div key={l.nome} style={{ marginBottom: 7 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, fontWeight: 700, color: '#0a1628' }}>
                    <span style={{ color: l.cor }}>{l.nome}</span><span>{l.v.toLocaleString('pt-BR')}</span>
                  </div>
                  <div style={{ background: '#f1f5f9', borderRadius: 4, height: 10 }}>
                    <div style={{ width: `${Math.max(2, l.v / max * 100)}%`, background: l.cor, height: 10, borderRadius: 4 }} />
                  </div>
                </div>
              ));
            })()}
          </div>
          <div style={secao}>
            <div style={tituloSec}>✅ Aproveitamento no exame ({periodo === '5anos' ? '5 anos' : periodo})</div>
            <div style={{ fontSize: 10.5, color: '#9ca3af', marginBottom: 6 }}>deferimentos ÷ (deferimentos + indeferimentos) — qualidade, não volume</div>
            {comparados.map((c, i) => {
              const def = totalPeriodo(c.marcos, 'deferimento');
              const ind = totalPeriodo(c.marcos, 'indeferimento');
              const pct = def + ind > 0 ? def / (def + ind) * 100 : null;
              return (
                <div key={c.nome} style={{ marginBottom: 7 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, fontWeight: 700 }}>
                    <span style={{ color: c.cor }}>{c.nome}</span>
                    <span style={{ color: pct === null ? '#9ca3af' : pct >= 70 ? '#15803d' : pct >= 50 ? '#b45309' : '#dc2626' }}>
                      {pct === null ? 'sem exames no período' : `${pct.toFixed(1)}% (${def.toLocaleString('pt-BR')}✓ ${ind.toLocaleString('pt-BR')}✗)`}
                    </span>
                  </div>
                  <div style={{ background: '#f1f5f9', borderRadius: 4, height: 10 }}>
                    <div style={{ width: `${Math.max(2, pct || 0)}%`, background: c.cor, height: 10, borderRadius: 4 }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 3. Fatia de mercado */}
        <div style={secao}>
          <div style={tituloSec}>🍕 Fatia de mercado — % dos {rotuloMarco.toLowerCase()} do INPI, mês a mês</div>
          {geral?.marcos ? (<>
            {grafLinhas(comparados.filter(c => !c.ehInpi).map((c) => {
              const meu = serieCont(c.marcos);
              const tudo = serieCont(geral.marcos);
              return { cor: c.cor, pontos: meu.map((v, k) => tudo[k] > 0 ? v / tudo[k] * 100 : 0) };
            }), v => `${v.toFixed(2)}%`)}
            {legenda}
            <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>Quem sobe aqui está ganhando terreno mesmo que o mercado inteiro caia.</div>
          </>) : <div style={{ fontSize: 12, color: '#9ca3af' }}>Carregando o total do INPI…</div>}
        </div>

        {/* 6. Crescimento YoY */}
        <div style={secao}>
          <div style={tituloSec}>📊 Crescimento ano contra ano — {rotuloMarco}</div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 480 }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', fontSize: 11, color: '#6b7280', padding: '3px 8px' }}>Procurador</th>
                  {ANOS5.slice(1).map(a => (
                    <th key={a} style={{ fontSize: 11, color: '#6b7280', padding: '3px 8px', textAlign: 'right' }}>
                      {a} vs {a - 1}{a === anoAtu ? '*' : ''}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparados.map((c, i) => (
                  <tr key={c.nome} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ fontSize: 11.5, fontWeight: 700, color: c.cor, padding: '5px 8px', whiteSpace: 'nowrap' }}>{c.nome}</td>
                    {ANOS5.slice(1).map(a => {
                      // Ano corrente compara só os meses já fechados dos dois anos (jan..último fechado)
                      const soma = (ano, ateM) => (c.marcos?.[marco]?.[ano] || []).slice(0, ateM).reduce((s, v) => s + v, 0);
                      const corte = a === anoAtu ? mesAtu : 12;
                      const atual = soma(a, corte);
                      const antes = soma(a - 1, corte);
                      const pct = antes > 0 ? (atual - antes) / antes * 100 : null;
                      return (
                        <td key={a} style={{ textAlign: 'right', padding: '5px 8px', fontSize: 12, fontWeight: 700, color: pct === null ? '#9ca3af' : pct >= 0 ? '#15803d' : '#dc2626' }}>
                          {pct === null ? '—' : `${pct >= 0 ? '+' : ''}${Math.round(pct)}%`}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>* {anoAtu} comparado com o MESMO trecho de {anoAtu - 1} (jan–{MESES_CURTOS[Math.max(0, mesAtu - 1)].toLowerCase()}), pra briga ser justa.</div>
        </div>

        {/* 7. Sazonalidade normalizada */}
        <div style={secao}>
          <div style={tituloSec}>🗓️ Sazonalidade normalizada — o "ritmo do ano" de cada um</div>
          <div style={{ fontSize: 10.5, color: '#9ca3af', marginBottom: 6 }}>média dos anos fechados, cada mês em % do total do próprio ano — compara o RITMO independente do tamanho</div>
          {(() => {
            const W = 760, H = 190, PAD = 46;
            const series = comparados.map((c) => {
              const med = Array(12).fill(0);
              let nAnos = 0;
              for (const a of ANOS5.filter(a => a !== anoAtu)) {
                const ms = c.marcos?.[marco]?.[a] || [];
                const tot = ms.reduce((s, v) => s + v, 0);
                if (tot > 0) { nAnos++; ms.forEach((v, k) => { med[k] += v / tot * 100; }); }
              }
              return { cor: c.cor, pontos: med.map(v => nAnos ? v / nAnos : 0) };
            });
            const maxV = Math.max(1, ...series.flatMap(s => s.pontos));
            const x = (k) => PAD + (k / 11) * (W - PAD - 10);
            const y = (v) => H - 26 - (v / maxV) * (H - 44);
            return (
              <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
                {[0.5, 1].map(f => (
                  <g key={f}>
                    <line x1={PAD} x2={W - 10} y1={y(maxV * f)} y2={y(maxV * f)} stroke="#eef2f7" strokeWidth="1" />
                    <text x={PAD - 4} y={y(maxV * f) + 3} textAnchor="end" fontSize="8.5" fill="#9ca3af">{(maxV * f).toFixed(1)}%</text>
                  </g>
                ))}
                {MESES_CURTOS.map((r, k) => <text key={r} x={x(k)} y={H - 10} textAnchor="middle" fontSize="8.5" fill="#6b7280">{r}</text>)}
                {series.map((s, si) => {
                  const ativo = destaque === null || destaque === si;
                  return (
                    <g key={si} opacity={ativo ? 1 : 0.12}>
                      <polyline fill="none" stroke={s.cor} strokeWidth={destaque === si ? 3 : 2}
                        points={s.pontos.map((v, k) => `${x(k)},${y(v)}`).join(' ')} />
                      {s.pontos.map((v, k) => <circle key={k} cx={x(k)} cy={y(v)} r="2" fill={s.cor} />)}
                    </g>
                  );
                })}
              </svg>
            );
          })()}
          {legenda}
        </div>
        {/* 🗺️ Mapa de calor + evolução do participante escolhido (mesmos
            dashboards da aba INPI, com os dados que o Comparativo já tem) */}
        <div style={secao}>
          <div style={tituloSec}>🗺️ Dashboards individuais — clique num participante</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: detalhe ? 12 : 0 }}>
            {comparados.map((c) => (
              <button key={c.nome} onClick={() => setDetalhe(detalhe === c.nome ? null : c.nome)}
                style={{ padding: '5px 12px', fontSize: 12, fontWeight: detalhe === c.nome ? 700 : 500, background: detalhe === c.nome ? c.cor : '#fff', color: detalhe === c.nome ? '#fff' : c.cor, border: `2px ${c.ehInpi ? 'dashed' : 'solid'} ${c.cor}`, borderRadius: 20, cursor: 'pointer' }}>
                {c.nome}
              </button>
            ))}
          </div>
          {(() => {
            const sel = comparados.find(c => c.nome === detalhe);
            if (!sel) return <div style={{ fontSize: 11.5, color: '#9ca3af', marginTop: 6 }}>Escolha um participante pra abrir o mapa de calor e a evolução ano a ano dele aqui dentro.</div>;
            return <RelatorioMercadoInpi key={sel.nome} dadosProntos={sel.marcos} rotuloProprio={sel.nome} />;
          })()}
        </div>
      </>)}
    </div>
  );
}

// 💡 INSIGHTS: rankings e séries que não dependem de saber nomes de antemão
const CLASSES_NCL = { '25': 'vestuário', '35': 'comércio/serviços', '41': 'educação/lazer', '43': 'alimentação', '30': 'alimentos', '44': 'saúde/beleza', '42': 'tecnologia', '05': 'farmacêuticos', '03': 'cosméticos', '29': 'alimentos', '09': 'eletrônicos', '36': 'financeiro', '37': 'construção', '45': 'jurídico/social', '33': 'bebidas alc.', '32': 'bebidas', '16': 'papelaria', '28': 'jogos/esporte' };

function RelatorioMercadoInsights() {
  const anoAtu = new Date().getFullYear();
  const mesAtu = new Date().getMonth();
  const [ano, setAno] = useState(anoAtu);
  const [marco, setMarco] = useState('publicado');
  const [dados, setDados] = useState(null);
  const [saz, setSaz] = useState(null);
  const [erro, setErro] = useState('');
  const [enviandoPdf, setEnviandoPdf] = useState(false);
  // Recorte por procuradores (até 5): painéis iguais, dados só deles
  const [procs, setProcs] = useState([]);
  const [buscaP, setBuscaP] = useState('');
  const chaveProcs = JSON.stringify(procs);

  useEffect(() => { apiFetch('/marcas-rpi/mercado/sazonalidade').then(setSaz).catch(() => {}); }, []);
  useEffect(() => {
    setDados(null); setErro('');
    const extra = procs.length ? `&procuradores=${encodeURIComponent(chaveProcs)}` : '';
    apiFetch(`/marcas-rpi/mercado/insights?ano=${ano}&marco=${marco}${extra}`).then(setDados).catch(e => setErro(e.message));
  }, [ano, marco, chaveProcs]);

  function addProc() {
    const n = buscaP.trim().toUpperCase();
    if (n.length < 4) return alert('Digite ao menos 4 letras.');
    if (procs.length >= 5) return alert('Máximo de 5 — remova um pra adicionar outro.');
    if (!procs.includes(n)) setProcs(l => [...l, n]);
    setBuscaP('');
  }

  async function enviarPdf() {
    setEnviandoPdf(true);
    try {
      await apiFetch('/marcas-rpi/mercado/relatorio-pdf', { method: 'POST', body: JSON.stringify({ ano }) });
      alert(`📄 Panorama de ${ano} gerado — chegando no seu WhatsApp.`);
    } catch (e) { alert('Falhou: ' + e.message); }
    setEnviandoPdf(false);
  }

  const secao = { background: '#fff', border: '1px solid #dbe2ea', borderRadius: 10, padding: '12px 16px' };
  const tituloSec = { fontSize: 13, fontWeight: 800, color: '#0a1628', marginBottom: 8 };
  const barras = (linhas, rotulo, extra) => {
    const max = Math.max(1, ...linhas.map(l => l.t));
    return linhas.map((l, i) => (
      <div key={l[rotulo]} style={{ marginBottom: 6 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5 }}>
          <span style={{ fontWeight: 700, color: '#0a1628' }}>{i + 1}º {l[rotulo]}{extra ? extra(l) : ''}</span>
          <span style={{ fontWeight: 700 }}>{l.t.toLocaleString('pt-BR')}</span>
        </div>
        <div style={{ background: '#f1f5f9', borderRadius: 4, height: 8 }}>
          <div style={{ width: `${Math.max(2, l.t / max * 100)}%`, background: '#1d4ed8', height: 8, borderRadius: 4 }} />
        </div>
      </div>
    ));
  };
  // Linha por ano (desassistidos e tempo de exame)
  const linhaAnos = (porAno, fmtY, unidade) => {
    const W = 760, H = 190, PAD = 46;
    const anosL = Object.keys(porAno || {}).map(Number).sort((a, b) => a - b);
    const series = anosL.map(a => ({
      ano: a,
      pontos: (porAno[a] || []).map((v, k) => ({ m: k + 1, v })).filter(p => p.v > 0 && !(a === anoAtu && p.m - 1 >= mesAtu)),
    })).filter(s => s.pontos.length);
    const maxV = Math.max(1, ...series.flatMap(s => s.pontos.map(p => p.v)));
    const x = (m) => PAD + ((m - 1) / 11) * (W - PAD - 10);
    const y = (v) => H - 26 - (v / maxV) * (H - 44);
    return (
      <>
        <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
          {[0.5, 1].map(f => (
            <g key={f}>
              <line x1={PAD} x2={W - 10} y1={y(maxV * f)} y2={y(maxV * f)} stroke="#eef2f7" strokeWidth="1" />
              <text x={PAD - 4} y={y(maxV * f) + 3} textAnchor="end" fontSize="8.5" fill="#9ca3af">{fmtY(maxV * f)}</text>
            </g>
          ))}
          {MESES_CURTOS.map((r, k) => <text key={r} x={x(k + 1)} y={H - 10} textAnchor="middle" fontSize="8.5" fill="#6b7280">{r}</text>)}
          {series.map(sr => (
            <g key={sr.ano}>
              <polyline fill="none" stroke={COR_ANO[sr.ano] || '#6b7280'} strokeWidth={sr.ano === anoAtu ? 3 : 1.8} opacity={sr.ano === anoAtu ? 1 : 0.7}
                points={sr.pontos.map(pp => `${x(pp.m)},${y(pp.v)}`).join(' ')} />
              {sr.pontos.map(pp => <circle key={pp.m} cx={x(pp.m)} cy={y(pp.v)} r={sr.ano === anoAtu ? 3 : 2} fill={COR_ANO[sr.ano] || '#6b7280'}><title>{`${MESES_CURTOS[pp.m - 1]}/${sr.ano}: ${pp.v.toLocaleString('pt-BR')} ${unidade}`}</title></circle>)}
            </g>
          ))}
        </svg>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 4 }}>
          {anosL.map(a => <span key={a} style={{ fontSize: 11.5, fontWeight: a === anoAtu ? 800 : 600, color: COR_ANO[a] || '#6b7280' }}>― {a}</span>)}
        </div>
      </>
    );
  };
  // Projeção: ritmo do ano corrente × 12
  const projecao = (porAno) => {
    const meses = porAno?.[anoAtu] || [];
    const fechados = meses.slice(0, mesAtu);
    const soma = fechados.reduce((a, b) => a + b, 0);
    return mesAtu > 0 && soma > 0 ? Math.round(soma / mesAtu * 12) : null;
  };
  const projM = projecao(saz?.marcos?.[marco]);
  const projP = projecao(saz?.preserva?.[marco]);
  const rotuloMarco = (MARCOS_MERCADO.find(m => m.key === marco)?.rotulo || '').replace(/^\S+\s/, '');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        {MARCOS_MERCADO.map(m => (
          <button key={m.key} onClick={() => setMarco(m.key)}
            style={{ padding: '5px 12px', fontSize: 12, fontWeight: marco === m.key ? 700 : 500, background: marco === m.key ? '#0a1628' : '#fff', color: marco === m.key ? '#fff' : '#374151', border: `1px solid ${marco === m.key ? '#0a1628' : '#c8d0da'}`, borderRadius: 20, cursor: 'pointer' }}>
            {m.rotulo}
          </button>
        ))}
        <span style={{ width: 1, height: 20, background: '#dbe2ea', margin: '0 4px' }} />
        {[anoAtu - 4, anoAtu - 3, anoAtu - 2, anoAtu - 1, anoAtu].map(a => (
          <button key={a} onClick={() => setAno(a)}
            style={{ padding: '4px 10px', fontSize: 11.5, fontWeight: ano === a ? 700 : 500, background: ano === a ? '#334155' : '#eef2f7', color: ano === a ? '#fff' : '#475569', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            {a}
          </button>
        ))}
        <span style={{ width: 1, height: 20, background: '#dbe2ea', margin: '0 4px' }} />
        <input value={buscaP} onChange={e => setBuscaP(e.target.value)} onKeyDown={e => e.key === 'Enter' && addProc()}
          placeholder="🔎 Recorte: procurador (até 5)…"
          style={{ width: 210, padding: '5px 10px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 12 }} />
        <button onClick={addProc} style={{ background: '#fff', color: '#0a1628', border: '1px solid #0a1628', borderRadius: 6, padding: '5px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>+</button>
        <button onClick={enviarPdf} disabled={enviandoPdf}
          style={{ marginLeft: 'auto', background: '#15803d', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer', opacity: enviandoPdf ? 0.6 : 1 }}>
          {enviandoPdf ? '⏳ Gerando…' : `📄 Panorama ${ano} em PDF no WhatsApp`}
        </button>
      </div>

      {procs.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: 11.5, fontWeight: 700, color: '#92400e' }}>Recorte ativo — painéis mostrando só:</span>
          {procs.map(n => (
            <span key={n} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 14, padding: '2px 10px', fontSize: 11.5, fontWeight: 700 }}>
              {n}<span onClick={() => setProcs(l => l.filter(x => x !== n))} style={{ cursor: 'pointer' }}>×</span>
            </span>
          ))}
          <span onClick={() => setProcs([])} style={{ fontSize: 11.5, color: '#1d4ed8', cursor: 'pointer', fontWeight: 700 }}>limpar (voltar ao Brasil inteiro)</span>
        </div>
      )}
      {erro && <div style={{ color: '#dc2626', fontSize: 13 }}>Erro: {erro}</div>}
      {!dados && !erro && <div style={{ color: '#6b7280', fontSize: 13 }}>Montando os rankings de {ano}…</div>}

      {(projM || projP) && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 8 }}>
          {projM && <div style={{ ...secao, padding: '10px 14px' }}><div style={{ fontSize: 10.5, color: '#6b7280', fontWeight: 700 }}>🔮 INPI: {rotuloMarco} projetados p/ {anoAtu}</div><div style={{ fontSize: 20, fontWeight: 800, color: '#0a1628' }}>{abreviaValor(projM)}</div><div style={{ fontSize: 10.5, color: '#9ca3af' }}>no ritmo de jan–{MESES_CURTOS[Math.max(0, mesAtu - 1)].toLowerCase()}</div></div>}
          {projP && <div style={{ ...secao, padding: '10px 14px' }}><div style={{ fontSize: 10.5, color: '#15803d', fontWeight: 700 }}>🔮 Preserva: {rotuloMarco} projetados p/ {anoAtu}</div><div style={{ fontSize: 20, fontWeight: 800, color: '#15803d' }}>{projP.toLocaleString('pt-BR')}</div><div style={{ fontSize: 10.5, color: '#9ca3af' }}>mesmo cálculo, sua carteira</div></div>}
        </div>
      )}

      {dados && (<>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 12 }}>
          <div style={secao}>
            <div style={tituloSec}>🏆 {dados.recorte ? 'Ranking dos selecionados' : 'Top 20 procuradores do Brasil'} — {rotuloMarco} em {ano}{dados.corte_mes < 12 ? ` (jan–${MESES_CURTOS[dados.corte_mes - 1].toLowerCase()})` : ''}</div>
            {barras(dados.top, 'nome')}
          </div>
          <div>
            <div style={{ ...secao, marginBottom: 12 }}>
              <div style={tituloSec}>🚀 {dados.recorte ? 'Crescimento dos selecionados' : 'Quem mais cresce'} ({ano} vs {ano - 1}, mesmo trecho)</div>
              {dados.emergentes.length === 0 && <div style={{ fontSize: 12, color: '#9ca3af' }}>Sem dados suficientes ainda.</div>}
              {dados.emergentes.map((x, i) => (
                <div key={x.nome} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, padding: '4px 0', borderBottom: '1px solid #f1f5f9' }}>
                  <span style={{ fontWeight: 700, color: '#0a1628' }}>{i + 1}º {x.nome}</span>
                  <span style={{ fontWeight: 800, color: x.cresc >= 0 ? '#15803d' : '#dc2626', whiteSpace: 'nowrap' }}>
                    {x.cresc >= 0 ? '↑ +' : '↓ '}{Math.round(x.cresc)}% ({x.antes.toLocaleString('pt-BR')}→{x.agora.toLocaleString('pt-BR')})
                  </span>
                </div>
              ))}
              <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 4 }}>concorrente novo acelerando aparece aqui antes de você sentir no mercado</div>
            </div>
            <div style={secao}>
              <div style={tituloSec}>🏷️ Classes {dados.recorte ? 'em que os selecionados atuam' : 'mais movimentadas'} em {ano}</div>
              {barras(dados.classes, 'codigo', l => CLASSES_NCL[l.codigo] ? ` · ${CLASSES_NCL[l.codigo]}` : '')}
            </div>
          </div>
        </div>

        <div style={secao}>
          <div style={tituloSec}>📍 Estados {dados.recorte ? 'onde os selecionados atuam' : 'que mais movimentam'} — {rotuloMarco} em {ano}</div>
          <div style={{ columnCount: 2, columnGap: 24 }}>{barras(dados.ufs, 'uf')}</div>
        </div>
      </>)}

      <div style={secao}>
        <div style={tituloSec}>🎯 Desassistidos — publicados SEM procurador (seu mercado de prospecção)</div>
        {saz?.desassistidos ? linhaAnos(saz.desassistidos, v => abreviaValor(Math.round(v)), 'publicados sem procurador') : <div style={{ fontSize: 12, color: '#9ca3af' }}>Contando… (aparece quando a recontagem em segundo plano terminar)</div>}
        <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>Quando esta linha sobe, o volume de leads possíveis do SDR sobe junto — régua pro ritmo das listas.</div>
      </div>

      <div style={secao}>
        <div style={tituloSec}>⏱️ Tempo de exame do INPI — meses entre publicação e deferimento</div>
        {saz?.exame_dias && Object.keys(saz.exame_dias).length ? linhaAnos(
          Object.fromEntries(Object.entries(saz.exame_dias).map(([a, ms]) => [a, ms.map(d => d > 0 ? +(d / 30).toFixed(1) : 0)])),
          v => `${v.toFixed(0)} m`, 'meses de exame')
          : <div style={{ fontSize: 12, color: '#9ca3af' }}>Calculando… (aparece quando a recontagem em segundo plano terminar)</div>}
        <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 4 }}>Resposta com dado real pra pergunta que todo cliente faz: "quanto tempo demora?".</div>
      </div>

      <div style={{ ...secao, background: '#fffbeb', border: '1px solid #fde68a' }}>
        <div style={{ fontSize: 11.5, color: '#92400e' }}>
          <b>📐 Metodologia:</b> os números contam <b>movimentações publicadas na RPI</b> — um processo republicado conta de novo, e o mês é o da publicação na revista (não o do depósito). Comparações, rankings e tendências são confiáveis; não usar como censo de pedidos únicos.
        </div>
      </div>
    </div>
  );
}

const SUBABAS_MERCADO = [
  { key: 'inpi', label: '🏛️ INPI', componente: RelatorioMercadoInpi },
  { key: 'preserva', label: '🛡️ Preserva Marcas', componente: RelatorioMercadoInpi, props: { fonte: 'preserva' } },
  { key: 'avulso', label: '🔎 Avulso', componente: RelatorioMercadoInpi, props: { fonte: 'avulso' } },
  { key: 'comparativo', label: '⚔️ Comparativo', componente: RelatorioMercadoComparativo },
  { key: 'insights', label: '💡 Insights', componente: RelatorioMercadoInsights },
];

function RelatorioMercado() {
  const [subAba, setSubAba] = useState('inpi');
  const subAtiva = SUBABAS_MERCADO.find(s => s.key === subAba);
  const Sub = subAtiva?.componente;
  return (
    <div>
      <div style={{ display: 'flex', gap: 4, marginBottom: 12, flexWrap: 'wrap' }}>
        {SUBABAS_MERCADO.map(s => (
          <button key={s.key} onClick={() => setSubAba(s.key)}
            style={{
              padding: '5px 14px', fontSize: 12.5, fontWeight: subAba === s.key ? 700 : 500,
              background: subAba === s.key ? '#334155' : '#eef2f7', color: subAba === s.key ? '#fff' : '#475569',
              border: '1px solid ' + (subAba === s.key ? '#334155' : '#dbe2ea'), borderRadius: 6, cursor: 'pointer',
            }}>
            {s.label}
          </button>
        ))}
      </div>
      {Sub && <Sub key={subAba} {...(subAtiva.props || {})} />}
    </div>
  );
}

export default function Relatorios() {
  const [abaAtiva, setAbaAtiva] = useState('comercial');
  // 👁️ Olhinho: esconde os números nas abas Vendas, Serviços e Faturamento
  // (Mercado ficou de fora a pedido do Vagner 21/08 — dado público do INPI)
  const [numerosOcultos, setNumerosOcultos] = useState(() => localStorage.getItem('relatorios_privado') === '1');
  const ABAS_COM_OLHINHO = ['vendas', 'servicos', 'faturamento'];
  // Chave de módulo definida ANTES dos filhos renderizarem (render é síncrono
  // de cima pra baixo) — nas outras abas fica sempre false
  PRIVADO = numerosOcultos && ABAS_COM_OLHINHO.includes(abaAtiva);
  // Montada a CADA render (não no carregamento do módulo): o login acontece
  // sem recarregar a página, então avaliar ehVagner() uma vez só fazia o
  // usuário herdar as abas do login anterior (Pedro via Faturamento Geral;
  // e no inverso, o Vagner às vezes não via as abas dele).
  const ABAS = [
    { key: 'comercial', label: '📊 Produção SDR', componente: RelatorioComercial },
    { key: 'clientes',  label: '👥 Clientes',     componente: RelatorioClientes },
    // Vendas: todos veem a aba, mas o servidor entrega só as vendas do
    // próprio consultor (Vagner vê tudo)
    { key: 'vendas', label: '💰 Vendas', componente: RelatorioVendas },
    // Serviços: quantidades por categoria/serviço (mesma regra de visibilidade)
    { key: 'servicos', label: '🧾 Serviços', componente: RelatorioServicos },
    // Comissões: todos veem a aba, mas o servidor entrega SÓ a linha do
    // próprio closer (Vagner vê todo mundo)
    { key: 'comissoes', label: '💸 Comissões', componente: RelatorioComissoes },
    ...(ehVagner() ? [
      // Origem: de onde vêm as vendas + atribuição retroativa (edição só Vagner)
      { key: 'origem', label: '📍 Origem', componente: RelatorioOrigem },
      { key: 'dre', label: '📑 DRE', componente: RelatorioDre },
      { key: 'faturamento', label: '🧾 Faturamento Geral', componente: RelatorioFaturamento },
      { key: 'sdr_analitics', label: '📞 SDR Analitics', componente: SdrAnalitics },
      { key: 'closer_analitics', label: '🧭 Closer Analitics', componente: CloserAnalitics },
      // Mercado: sazonalidade das movimentações do INPI (base RPI, 5 anos)
      { key: 'mercado', label: '🌡️ Mercado', componente: RelatorioMercado },
    ] : []),
    // Adicionar novas abas aqui
  ];
  const Componente = ABAS.find(a => a.key === abaAtiva)?.componente;

  return (
    <div>
      {/* Cabeçalho */}
      <div style={{ marginBottom: 14 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>Central de Relatórios</h1>
        <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>Análise e indicadores do negócio</p>
      </div>

      {/* Navegação por abas */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 16, borderBottom: '2px solid #c8d0da', paddingBottom: 0, flexWrap: 'wrap' }}>
        {ABAS.map(aba => (
          <button
            key={aba.key}
            onClick={() => setAbaAtiva(aba.key)}
            style={{
              padding: '7px 16px',
              fontSize: 13,
              fontWeight: abaAtiva === aba.key ? 700 : 500,
              background: abaAtiva === aba.key ? '#0a1628' : '#e8edf2',
              color: abaAtiva === aba.key ? '#fff' : '#374151',
              border: 'none',
              borderRadius: '6px 6px 0 0',
              cursor: 'pointer',
              marginBottom: -2,
              borderBottom: abaAtiva === aba.key ? '2px solid #0a1628' : '2px solid transparent',
            }}
          >
            {aba.label}
          </button>
        ))}
        {ABAS_COM_OLHINHO.includes(abaAtiva) && (
          <button
            onClick={() => {
              localStorage.setItem('relatorios_privado', numerosOcultos ? '0' : '1');
              setNumerosOcultos(o => !o);
            }}
            title={numerosOcultos ? 'Os números estão escondidos — clique pra mostrar' : 'Esconder os números da tela (modo privacidade)'}
            style={{
              marginLeft: 'auto', padding: '6px 14px', fontSize: 12.5, fontWeight: 700,
              background: numerosOcultos ? '#fef3c7' : '#fff', color: numerosOcultos ? '#92400e' : '#374151',
              border: `1px solid ${numerosOcultos ? '#fcd34d' : '#c8d0da'}`, borderRadius: 20, cursor: 'pointer',
              alignSelf: 'center', marginBottom: 4,
            }}>
            {numerosOcultos ? '🙈 Números ocultos' : '👁️ Ocultar números'}
          </button>
        )}
      </div>

      {/* Conteúdo da aba */}
      {Componente && <Componente />}
    </div>
  );
}
